import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.trim.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Base from "./Base";
import { computed, observable, makeObservable, runInAction, action, reaction } from "mobx";
import CreditCardModel from "./models/CreditCardModel";
import GiftCardModel from "./models/GiftCardModel";
import GratuityModel from "./models/GratuityModel";
import DPServices from "@dp/services";
import * as common from "@dp/common";
import CouponModel from "./models/CouponModel";
import * as utils from "../utils";
import { encryptAccount } from "../utils/encryption";
import moment from "moment-timezone";
import Errors, { ERROR_STRINGS } from "./Errors";
import BrandRules from "../utils/BrandRules";
var Payment = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Payment, _Base);

  var _super = _createSuper(Payment); //if user needs to re-enter CVV for a saved card


  function Payment(rootStore) {
    var _this;

    _classCallCheck(this, Payment);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "_userProfile", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_activePaymentTab", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_activeOtherOptionTab", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_giftCards", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_creditCards", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_subTotalWithoutItemDiscount", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_paymentCVV", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_componentRef", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_paymentCVVEnabled", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_sessionToken", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_rsaToken", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_encryptionFields", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_appAttributes", _descriptor13, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isCCPaymentDisabled", _descriptor14, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_payPalErrored", _descriptor15, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_applePayErrored", _descriptor16, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_googlePayErrored", _descriptor17, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isGCFailureLimitReached", _descriptor18, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "gratuityModel", null);

    _defineProperty(_assertThisInitialized(_this), "creditCardInfo", null);

    _defineProperty(_assertThisInitialized(_this), "couponModel", null);

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "giftCardInfo", _descriptor19, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_payPalData", _descriptor20, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_savedGiftCardsLimit", _descriptor21, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_orderPriceInfo", _descriptor22, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_tippableAmount", _descriptor23, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_formSubmitted", _descriptor24, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isPayPalEnabled", _descriptor25, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isGooglePayEnabled", _descriptor26, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isApplePayEnabled", _descriptor27, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isGiftCardPaymentEnabled", _descriptor28, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_allowedPaymentMethods", _descriptor29, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_giftCardRecaptchaSiteKey", _descriptor30, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_applePaySession", _descriptor31, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_applePayAuthorization", _descriptor32, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_googlePayAuthorization", _descriptor33, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_fallbackReasonCode", _descriptor34, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_flow", _descriptor35, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_maximumGCAllowedPerOrder", _descriptor36, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_errorsYPosition", _descriptor37, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showError", _descriptor38, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_requestPhoneNumberFromAppleOrGooglePay", _descriptor39, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_orderSessionRSARetryCount", _descriptor40, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_requestShippingFieldsFromAppleOrGooglePay", _descriptor41, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isGCLimitExceeded", _descriptor42, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isCCLimitExceeded", _descriptor43, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "setErrorsYPosition", function (code, yPos) {
      runInAction(function () {
        _this._errorsYPosition[code] = yPos;
      });
    });

    _this.rootStore = rootStore;
    _this.gratuityModel = new GratuityModel(_this.rootStore.platformUtil);
    _this.creditCardInfo = new CreditCardModel(true, true);
    _this.giftCardInfo = new GiftCardModel();
    _this.couponModel = new CouponModel();
    runInAction(function () {
      _this._activePaymentTab = utils.PaymentMethods.ONLINE;
      _this._activeOtherOptionTab = utils.OnlinePaymentTypes.NONE;
      _this._giftCards = [];
      _this._creditCards = [];
      _this._paymentCVV = "";
      _this.appMessages = rootStore.appMessages;
    });
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Payment, [{
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this; //app-init


      reaction(function () {
        return {
          appAttributes: _this2.rootStore.common.appAttributes
        };
      }, function (data) {
        _this2._processAppAttributes(data.appAttributes);
      }); //user-profile & payment-methods

      reaction(function () {
        return {
          userProfile: _this2.rootStore.user.userProfile,
          isLoggedIn: _this2.rootStore.user.isLoggedIn
        };
      }, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this2._processUserProfile(data.isLoggedIn, data.userProfile);

                  if (!data.isLoggedIn) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 4;
                  return _this2.fetchAndUpdatePaymentMethods();

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "_processUserProfile",
    value: function _processUserProfile(isLoggedIn, userProfile) {
      if (isLoggedIn && userProfile) {
        this.creditCardInfo.fullAVSEnabled = true;
        this.creditCardInfo.saveCreditCard = true;
        this.creditCardInfo.saveCardMandateEnabled = true;
        this.creditCardInfo.agreeDisclaimer = true;
        this.userProfile = userProfile;
      }
    }
  }, {
    key: "_processAppAttributes",
    value: function _processAppAttributes(appAttributes) {
      var _this3 = this;

      this._appAttributes = appAttributes;

      if (appAttributes) {
        var appConfig = appAttributes.configs;
        var paymentCVV_enabled = appConfig.paymentCVV_enabled;

        if (paymentCVV_enabled) {
          this.paymentCVVEnabled = paymentCVV_enabled === "true" ? true : false;
        }

        this.savedGiftCardsLimit = appAttributes.SavedGiftCardMaxLimit;
      }

      if (appAttributes !== null && appAttributes !== void 0 && appAttributes.configs) {
        runInAction(function () {
          _this3._giftCardRecaptchaSiteKey = appAttributes.configs.gcbalance_captcha_public_key;
        });
      }
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$rootStore, _this$rootStore$user, _this$rootStore2, _this$rootStore2$user;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.reset();
                _context2.next = 3;
                return common.handle(this.rootStore.platformUtil.hydrateUsingSessionStorage(["GRATUITY_INFO"].join("-"), this.gratuityModel));

              case 3:
                this._processAppAttributes(this.rootStore.common.appAttributes);

                this._processUserProfile((_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.isLoggedIn, (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$user = _this$rootStore2.user) === null || _this$rootStore2$user === void 0 ? void 0 : _this$rootStore2$user.userProfile);

                this.fetchAndUpdatePaymentMethods();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                runInAction(function () {
                  var _this4$creditCardInfo, _this4$couponModel;

                  _this4._paymentCVVEnabled = false;
                  _this4._isCCPaymentDisabled = false;
                  _this4._payPalErrored = false;
                  _this4._applePayErrored = false;
                  _this4._googlePayErrored = false;
                  _this4._savedGiftCardsLimit = null;
                  _this4._formSubmitted = false;
                  _this4._isPayPalEnabled = false;
                  _this4._isGooglePayEnabled = false;
                  _this4._isApplePayEnabled = false;
                  _this4._isGiftCardPaymentEnabled = true;
                  _this4._allowedPaymentMethods = "PAY_ONLINE";
                  _this4._maximumGCAllowedPerOrder = null;
                  _this4._activePaymentTab = utils.PaymentMethods.ONLINE;
                  _this4._activeOtherOptionTab = utils.OnlinePaymentTypes.NONE;
                  _this4._paymentCVV = "";
                  _this4._requestPhoneNumberFromAppleOrGooglePay = true;
                  _this4._requestShippingFieldsFromAppleOrGooglePay = true;
                  (_this4$creditCardInfo = _this4.creditCardInfo) === null || _this4$creditCardInfo === void 0 ? void 0 : _this4$creditCardInfo.resetCreditCardModel();
                  (_this4$couponModel = _this4.couponModel) === null || _this4$couponModel === void 0 ? void 0 : _this4$couponModel.resetModel();
                  _this4._orderSessionRSARetryCount = common.toInteger(common.getEnvProps()["NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT"], 2);
                  _this4._isGCLimitExceeded = false;
                  _this4._isCCLimitExceeded = false;
                  _this4._flow = null;
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "handleInvalidModel",
    value: function handleInvalidModel(appMessages) {
      var _this5 = this;

      var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      appMessages.showError("Missing Details", this.activeOtherOptionTab === utils.OnlinePaymentTypes.NONE ? "Please select a Payment method." : "Please enter all required fields.", null, {
        okBtnText: "OK",
        okBtnOnClick: function okBtnOnClick() {
          _this5.rootStore.platformUtil.scrollToElement(_this5.componentRef, isMobile ? 50 : 0);
        }
      });
      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "DisplayModal", {
        modalIntent: "Error modal for missing payment",
        modalContent: "Error modal for missing payment",
        modalName: "PaymentInfo-Error-Modal"
      });
    }
  }, {
    key: "showMaxGCExceededPopup",
    value: function showMaxGCExceededPopup() {
      this.appMessages.showError("Max ".concat(this.maximumGCAllowedPerOrder, " gift card(s) allowed per order"), "You can only select ".concat(this.maximumGCAllowedPerOrder, " gift card(s) for online payment of this order. If you would like to use more than ").concat(this.maximumGCAllowedPerOrder, " gift card(s) please contact your server."), null, {
        okBtnText: "OK"
      });
    }
  }, {
    key: "addNewGiftCard",
    value: function addNewGiftCard() {
      var isSavedCard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var rawGiftCardNumber = this.giftCardInfo.gcNumber.replace(/-/g, "");

      if (rawGiftCardNumber) {
        var _this$giftCardInfo$gi;

        var filtered = this._giftCards.filter(function (gc) {
          return gc.card.giftCardNumber === rawGiftCardNumber;
        });

        var uiCard = {
          card: {
            giftCardBalance: this.giftCardInfo.gcBalance,
            giftCardInfoId: ((_this$giftCardInfo$gi = this.giftCardInfo.giftCardID) === null || _this$giftCardInfo$gi === void 0 ? void 0 : _this$giftCardInfo$gi.toString()) || moment().toDate().getTime().toString(),
            giftCardName: this.giftCardInfo.rawGCNumber,
            giftCardNumber: this.giftCardInfo.rawGCNumber
          },
          amountUsed: 0,
          proratedAmount: 0,
          proratedTip: 0,
          selectionOrder: 0,
          isVisible: true,
          isSelected: false,
          isDisabled: false,
          isSavedCard: isSavedCard
        };

        if (filtered.length === 0) {
          this._giftCards.push(uiCard);
        }

        if (!this.isMaxGCLimit) {
          this.selectGiftCard(uiCard, true);
        }

        this.giftCardInfo = new GiftCardModel();
      }

      return true;
    }
  }, {
    key: "clearGiftCard",
    value: function clearGiftCard() {
      this.giftCardInfo = new GiftCardModel();
    }
  }, {
    key: "setGiftCards",
    value: function setGiftCards(savedGiftCards) {
      var _this6 = this;

      runInAction(function () {
        _this6._giftCards = savedGiftCards ? savedGiftCards.map(function (savedCard) {
          return {
            card: savedCard,
            amountUsed: 0,
            proratedAmount: 0,
            proratedTip: 0,
            isDisabled: savedCard.giftCardBalance <= 0,
            isSelected: false,
            isVisible: true,
            selectionOrder: 0,
            isSavedCard: true
          };
        }) : [];
      });
    }
  }, {
    key: "selectGiftCard",
    value: function selectGiftCard(card, checked) {
      var _this7 = this;

      runInAction(function () {
        var selCard = _this7._giftCards.find(function (item) {
          return item.card.giftCardNumber === card.card.giftCardNumber;
        });

        selCard.isSelected = checked;

        if (checked) {
          var list = _this7._giftCards.map(function (gCard) {
            return gCard.selectionOrder;
          }); // eslint-disable-next-line prefer-spread


          var maxSelOrderInArr = Math.max.apply(Math, list);
          selCard.selectionOrder = maxSelOrderInArr + 1;
        }
      });
    }
  }, {
    key: "setCreditCards",
    value: function setCreditCards(savedCreditCards) {
      var _this8 = this;

      runInAction(function () {
        _this8._creditCards = savedCreditCards ? savedCreditCards.map(function (savedCard, i) {
          return {
            index: i,
            card: savedCard,
            proratedAmount: 0,
            proratedTip: 0,
            isDisabled: false,
            isSelected: false,
            isVisible: true,
            paymentCVV: null,
            hasExpired: _this8._hasExpired(savedCard),
            isDefault: savedCard.isDefault
          };
        }).sort(function (creditCard01, creditCard02) {
          if (creditCard01.isDefault) {
            return -1;
          } else if (creditCard02.isDefault) {
            return 1;
          } else {
            return 0;
          }
        }) : [];
      });
    }
  }, {
    key: "_hasExpired",
    value: function _hasExpired(card) {
      try {
        var creditCardDate = moment(card.expirationYear + card.expirationMonth, "YYMM");
        var today = moment();
        return creditCardDate.isValid() && today > creditCardDate.add(1, "months");
      } catch (err) {
        return true;
      }
    }
  }, {
    key: "selectCreditCard",
    value: function selectCreditCard(card) {
      this._creditCards = this._creditCards.map(function (item) {
        if (card.card.paymentCardToken === item.card.paymentCardToken) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }

        return item;
      });
      this._activeOtherOptionTab = utils.OnlinePaymentTypes.NONE;
    }
  }, {
    key: "deSelectCreditCards",
    value: function deSelectCreditCards() {
      if (this._creditCards.length) {
        this._creditCards = this._creditCards.map(function (item) {
          item.isSelected = false;
          return item;
        });
      }
    }
  }, {
    key: "deSelectGiftCards",
    value: function deSelectGiftCards() {
      if (this._giftCards.length) {
        this._giftCards = this._giftCards.map(function (item) {
          item.isSelected = false;
          return item;
        });
      }
    }
  }, {
    key: "removeGiftCard",
    value: function removeGiftCard(uiCard) {
      var remainingCards = [];

      this._giftCards.forEach(function (card) {
        if (card.card.giftCardNumber !== uiCard.card.giftCardNumber) {
          remainingCards.push(card);
        }
      });

      this._giftCards = remainingCards;
    }
  }, {
    key: "getAuthAndTipAmounts",
    value: function getAuthAndTipAmounts(totalAmount, tipPercent) {
      var totalProratedTip = totalAmount * tipPercent;

      if (totalProratedTip > totalAmount) {
        return {
          authAmount: 0.01,
          tipAmount: common.roundTo(totalAmount, 2) - 0.01
        };
      } else {
        return {
          authAmount: common.roundTo(totalAmount - totalProratedTip, 2),
          tipAmount: common.roundTo(totalProratedTip, 2)
        };
      }
    }
  }, {
    key: "getApplePayMerchantSession",
    value: function () {
      var _getApplePayMerchantSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(validationUrl) {
        var _common$getEnvProps, NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV, DEVELOPMENT, JWT_TOKEN, _yield$common$handle, _yield$common$handle2, err, resp;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _common$getEnvProps = common.getEnvProps(), NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = _common$getEnvProps.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV;
                DEVELOPMENT = NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV === "development";

                if (!this.rootStore.user.isLoggedIn) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 5;
                return this.rootStore.user.ensureAuth();

              case 5:
                _context5.t0 = _context5.sent;
                _context5.next = 9;
                break;

              case 8:
                _context5.t0 = null;

              case 9:
                JWT_TOKEN = _context5.t0;
                _context5.next = 12;
                return common.handle(DPServices.Payment.getApplePaySessionToken(JWT_TOKEN, this.trackingIdWRTFlow, this.flow, this.rootStore.platformUtil.getHostName()));

              case 12:
                _yield$common$handle = _context5.sent;
                _yield$common$handle2 = _slicedToArray(_yield$common$handle, 2);
                err = _yield$common$handle2[0];
                resp = _yield$common$handle2[1];

                if (!err) {
                  _context5.next = 20;
                  break;
                }

                throw err;

              case 20:
                return _context5.abrupt("return", resp);

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getApplePayMerchantSession(_x2) {
        return _getApplePayMerchantSession.apply(this, arguments);
      }

      return getApplePayMerchantSession;
    }()
  }, {
    key: "getGiftCardBalance",
    value: function () {
      var _getGiftCardBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this9 = this;

        var _this$rootStore3, _this$rootStore3$user, rawGCNumber, payload, JWT_TOKEN, giftCardData, errorUI;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                rawGCNumber = this.giftCardInfo.gcNumber.replace(/-/g, "");
                payload = {
                  giftCardNumber: rawGCNumber,
                  gRecaptchaResponse: this.giftCardInfo.captchaToken,
                  trackingId: this.trackingIdWRTFlow
                };
                _context6.next = 5;
                return (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$user = _this$rootStore3.user) === null || _this$rootStore3$user === void 0 ? void 0 : _this$rootStore3$user.getTokenSilentIfLoggedIn();

              case 5:
                JWT_TOKEN = _context6.sent;
                _context6.next = 8;
                return DPServices.Payment.getGiftCardBalance(payload, JWT_TOKEN);

              case 8:
                giftCardData = _context6.sent;

                if (!(giftCardData.data.giftCardBalance > 0)) {
                  _context6.next = 13;
                  break;
                }

                runInAction(function () {
                  _this9.giftCardInfo.gcBalance = giftCardData.data.giftCardBalance;
                  _this9.giftCardInfo.errorMessage = "";
                });
                _context6.next = 18;
                break;

              case 13:
                if (!(giftCardData.data.giftCardBalance === 0)) {
                  _context6.next = 17;
                  break;
                }

                throw Errors.NO_BALANCE_ON_GIFT_CARD;

              case 17:
                throw Errors.UNABLE_TO_PROCESS_REQUEST_AT_THIS_TIME;

              case 18:
                _context6.next = 25;
                break;

              case 20:
                _context6.prev = 20;
                _context6.t0 = _context6["catch"](0);
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context6.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.GET_GIFT_CARDS_BALANCE_FAILED.message
                });
                this.giftCardInfo.errorMessage = errorUI.message;
                throw _context6.t0;

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 20]]);
      }));

      function getGiftCardBalance() {
        return _getGiftCardBalance.apply(this, arguments);
      }

      return getGiftCardBalance;
    }()
  }, {
    key: "saveGiftCardToProfile",
    value: function () {
      var _saveGiftCardToProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(isPaymentFlow) {
        var _this$rootStore$check, _this$rootStore$check2, _this$rootStore4, _this$rootStore4$plat, rawGCNumber, payload, JWT_TOKEN, saveGiftCardResponse, newGiftCardData, errorUI;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                if (!this.canAddGiftCard) {
                  _context7.next = 13;
                  break;
                }

                rawGCNumber = this.giftCardInfo.gcNumber.replace(/-/g, "");
                payload = {
                  giftCardName: rawGCNumber,
                  giftCardNumber: rawGCNumber,
                  gRecaptchaResponse: this.giftCardInfo.captchaToken,
                  orderId: (_this$rootStore$check = (_this$rootStore$check2 = this.rootStore.checkout) === null || _this$rootStore$check2 === void 0 ? void 0 : _this$rootStore$check2.cartOrder.orderId) !== null && _this$rootStore$check !== void 0 ? _this$rootStore$check : null
                };
                _context7.next = 6;
                return this.rootStore.user.ensureAuth();

              case 6:
                JWT_TOKEN = _context7.sent;
                _context7.next = 9;
                return DPServices.Payment.saveGiftCard(JWT_TOKEN, payload);

              case 9:
                saveGiftCardResponse = _context7.sent;
                (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$plat = _this$rootStore4.platformUtil) === null || _this$rootStore4$plat === void 0 ? void 0 : _this$rootStore4$plat.dispatchEvent("AnalyticsEvent", "credit card added", {}); // the new card is added explicitly if payment-flow is active;T here could be temporary cards as well.

                if (isPaymentFlow) {
                  newGiftCardData = saveGiftCardResponse.giftCards.find(function (giftCard) {
                    return giftCard.giftCardNumber === rawGCNumber;
                  });
                  this.giftCardInfo.gcBalance = newGiftCardData.giftCardBalance;
                  this.giftCardInfo.giftCardID = newGiftCardData.giftCardInfoId;
                  this.giftCardInfo.gcNumber = newGiftCardData.giftCardName;
                  this.giftCardInfo.gcNumber = newGiftCardData.giftCardNumber;
                  this.addNewGiftCard(true);
                } else {
                  this.setGiftCards(saveGiftCardResponse.giftCards);
                  this.giftCardInfo = new GiftCardModel();
                }

                this.isGCLimitExceeded = saveGiftCardResponse.isGCLimitExceeded;

              case 13:
                _context7.next = 20;
                break;

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7["catch"](0);
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context7.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.SAVE_GIFT_CARD_TO_PROFILE_FAILED.message
                });
                this.giftCardInfo.errorMessage = errorUI.message;
                throw _context7.t0;

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 15]]);
      }));

      function saveGiftCardToProfile(_x3) {
        return _saveGiftCardToProfile.apply(this, arguments);
      }

      return saveGiftCardToProfile;
    }()
  }, {
    key: "tokenizeCreditCardPayment",
    value: function () {
      var _tokenizeCreditCardPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(merchantId, paymentCorrelationId, orderId, sessionTokenSource) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.tokenizeCreditCardPaymentRSA(paymentCorrelationId, orderId, merchantId, sessionTokenSource);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function tokenizeCreditCardPayment(_x4, _x5, _x6, _x7) {
        return _tokenizeCreditCardPayment.apply(this, arguments);
      }

      return tokenizeCreditCardPayment;
    }()
  }, {
    key: "tokenizeCreditCardPaymentRSA",
    value: function () {
      var _tokenizeCreditCardPaymentRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(paymentCorrelationId, orderId, merchantId, sessionTokenSource) {
        var _this$rootStore5, _this$rootStore5$user, _orderRSAToken$status;

        var payload, JWT_TOKEN, _yield$common$handle3, _yield$common$handle4, orderRSATokenErr, orderRSATokenResponse, orderRSAToken, _err$errors, err, BFaultExists, TFaultExists, rsaToken, encryptionFields, expiryDate, billingAddressFullAVS, billingAddressPartialAVS, isPartialAVS, billingAddress, cardType, cardTypeCORS, credit, type, account, referenceToken, _payload, _yield$common$handle5, _yield$common$handle6, payTokenErr, paymentToken, _accountTokenError$re, _accountTokenError$re2, _accountTokenError$re3, _this$rootStore6, _this$rootStore6$user, accountTokenError, reqPayload, _JWT_TOKEN, isBusinessFault, _err;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!this.isOrderSessionRSARetryCountExhausted) {
                  _context9.next = 4;
                  break;
                }

                this.isCCPaymentDisabled = true;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ERROR_MAX_ATTEMPTS_REACHED;

              case 4:
                payload = {
                  transactionType: common.RSATokenTransactionType[sessionTokenSource],
                  retryCount: this.orderSessionRSARetryCount,
                  trackingId: this.trackingIdWRTFlow,
                  paymentCorrelationId: paymentCorrelationId
                };
                _context9.next = 7;
                return (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$user = _this$rootStore5.user) === null || _this$rootStore5$user === void 0 ? void 0 : _this$rootStore5$user.getTokenSilentIfLoggedIn();

              case 7:
                JWT_TOKEN = _context9.sent;
                _context9.next = 10;
                return common.handle(DPServices.Payment.getRSAToken(payload, JWT_TOKEN));

              case 10:
                _yield$common$handle3 = _context9.sent;
                _yield$common$handle4 = _slicedToArray(_yield$common$handle3, 2);
                orderRSATokenErr = _yield$common$handle4[0];
                orderRSATokenResponse = _yield$common$handle4[1];
                orderRSAToken = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.rsaData;
                this.orderSessionRSARetryCount = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.retryRemaining;

                if (!(orderRSATokenErr || orderRSAToken.status === "FAILURE" || ((_orderRSAToken$status = orderRSAToken.status) === null || _orderRSAToken$status === void 0 ? void 0 : _orderRSAToken$status.toUpperCase()) === "ERROR")) {
                  _context9.next = 37;
                  break;
                } // all the retry attempts are already exhausted by RSAToken API


                this.orderSessionRSARetryCount = 0;

                if (!orderRSATokenErr) {
                  _context9.next = 32;
                  break;
                }

                err = orderRSATokenErr;

                if (!(((_err$errors = err.errors) === null || _err$errors === void 0 ? void 0 : _err$errors.length) > 0)) {
                  _context9.next = 32;
                  break;
                }

                this.isCCPaymentDisabled = true;
                this.creditCardInfo.paymentToken = null;
                BFaultExists = err.errors.some(function (errorObj) {
                  return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.code) === "BFAULT";
                });
                TFaultExists = err.errors.some(function (errorObj) {
                  return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.code) === "TFAULT";
                });

                if (!BFaultExists) {
                  _context9.next = 29;
                  break;
                }

                throw common.ERRORS.ERROR_MAX_ATTEMPTS_REACHED;

              case 29:
                if (!TFaultExists) {
                  _context9.next = 31;
                  break;
                }

                throw common.ERRORS.ERROR_SESSION_TOKEN_FAILURE;

              case 31:
                throw common.ERRORS.ERROR_TOKEN_UNKNOWN_FAULT_CASE;

              case 32:
                this.isCCPaymentDisabled = true;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ERROR_SESSION_TOKEN_FAILURE;

              case 37:
                this.isCCPaymentDisabled = false;
                this.rsaToken = orderRSAToken;

              case 39:
                rsaToken = this.rsaToken;

                if (!(rsaToken && rsaToken.publicKey && rsaToken.tokenId)) {
                  _context9.next = 99;
                  break;
                }

                encryptionFields = {
                  securityCode: this.creditCardInfo.cardAccountRSA.credit.securityCode,
                  paymentCardToken: this.creditCardInfo.cardAccountRSA.credit.cardNumber,
                  expirationMonth: this.creditCardInfo.cardAccountRSA.credit.expiryDate.month,
                  expirationYear: this.creditCardInfo.cardAccountRSA.credit.expiryDate.year
                };
                _context9.next = 44;
                return common.handle(encryptAccount(encryptionFields, rsaToken));

              case 44:
                // Assemble Payload for PaymentTokenRequestRSA
                expiryDate = {
                  year: encryptionFields.expirationYear,
                  month: encryptionFields.expirationMonth
                };
                billingAddressFullAVS = this.creditCardInfo.cardAccountRSA.credit.billingAddress;
                billingAddressPartialAVS = {
                  postalCode: this.creditCardInfo.cardAccountRSA.credit.billingAddress.postalCode
                };
                isPartialAVS = this.creditCardInfo.cardAccountRSA.credit.billingAddress.streetAddress === null || this.creditCardInfo.cardAccountRSA.credit.billingAddress.streetAddress === undefined; // Only send zip code in case of partial AVS

                billingAddress = isPartialAVS ? billingAddressPartialAVS : billingAddressFullAVS;
                cardType = this.creditCardInfo.cardAccountRSA.credit.cardType.toLowerCase();
                cardTypeCORS = "VISA";
                _context9.t0 = cardType;
                _context9.next = _context9.t0 === "mastercard" ? 54 : _context9.t0 === "american-express" ? 56 : _context9.t0 === "amex" ? 58 : _context9.t0 === "discover" ? 60 : _context9.t0 === "jcb" ? 62 : _context9.t0 === "diners-club" ? 64 : 66;
                break;

              case 54:
                cardTypeCORS = "MASTERCARD";
                return _context9.abrupt("break", 67);

              case 56:
                cardTypeCORS = "AMEX";
                return _context9.abrupt("break", 67);

              case 58:
                cardTypeCORS = "AMEX";
                return _context9.abrupt("break", 67);

              case 60:
                cardTypeCORS = "DISCOVER";
                return _context9.abrupt("break", 67);

              case 62:
                cardTypeCORS = "DISCOVER";
                return _context9.abrupt("break", 67);

              case 64:
                cardTypeCORS = "DISCOVER";
                return _context9.abrupt("break", 67);

              case 66:
                return _context9.abrupt("break", 67);

              case 67:
                credit = {
                  securityCode: encryptionFields.securityCode,
                  cardType: cardTypeCORS,
                  expiryDate: expiryDate,
                  cardNumber: encryptionFields.paymentCardToken,
                  nameOnCard: this.creditCardInfo.cardAccountRSA.credit.nameOnCard,
                  billingAddress: billingAddress
                };
                type = "CREDIT";
                account = {
                  type: type,
                  credit: credit
                };
                referenceToken = {
                  tokenType: "TRANS_ARMOR"
                };
                _payload = {
                  merchantId: merchantId,
                  account: account,
                  referenceToken: referenceToken
                };
                _context9.next = 74;
                return common.handle(DPServices.Payment.getPaymentTokenRSA(rsaToken, _payload));

              case 74:
                _yield$common$handle5 = _context9.sent;
                _yield$common$handle6 = _slicedToArray(_yield$common$handle5, 2);
                payTokenErr = _yield$common$handle6[0];
                paymentToken = _yield$common$handle6[1];

                if (!(paymentToken && paymentToken.paymentToken)) {
                  _context9.next = 83;
                  break;
                }

                this.sessionToken = null;
                this.creditCardInfo.paymentToken = paymentToken;
                _context9.next = 99;
                break;

              case 83:
                // enforcing type because of the handle method above
                accountTokenError = payTokenErr;
                reqPayload = this.getTokenizationFailureLogRequestRSA(orderId, (_accountTokenError$re = accountTokenError.response) === null || _accountTokenError$re === void 0 ? void 0 : (_accountTokenError$re2 = _accountTokenError$re.data) === null || _accountTokenError$re2 === void 0 ? void 0 : (_accountTokenError$re3 = _accountTokenError$re2.code) === null || _accountTokenError$re3 === void 0 ? void 0 : _accountTokenError$re3.toString());
                _context9.next = 87;
                return (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$user = _this$rootStore6.user) === null || _this$rootStore6$user === void 0 ? void 0 : _this$rootStore6$user.getTokenSilentIfLoggedIn();

              case 87:
                _JWT_TOKEN = _context9.sent;
                _context9.next = 90;
                return common.handle(DPServices.Payment.logCCTokenizationFailure(reqPayload, _JWT_TOKEN));

              case 90:
                this.creditCardInfo.paymentToken = null;
                this.sessionToken = null;

                if (payTokenErr) {
                  _err = payTokenErr;

                  if (_err.response) {
                    // Axios Error (CORS error) = Technical Fault
                    isBusinessFault = false;
                  } else {
                    // 400 Error = Business Fault
                    isBusinessFault = true;
                  }
                } else {
                  isBusinessFault = true;
                }

                if (!isBusinessFault) {
                  _context9.next = 97;
                  break;
                }

                throw common.ERRORS.CC_TOKENIZATION_BUSINESS_FAULT;

              case 97:
                this.isCCPaymentDisabled = true;
                throw common.ERRORS.CC_TOKENIZATION_TECHNICAL_FAILURE;

              case 99:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function tokenizeCreditCardPaymentRSA(_x8, _x9, _x10, _x11) {
        return _tokenizeCreditCardPaymentRSA.apply(this, arguments);
      }

      return tokenizeCreditCardPaymentRSA;
    }()
  }, {
    key: "getTokenizationFailureLogRequest",
    value: function getTokenizationFailureLogRequest(orderId) {
      var _card$cardNumber, _cardNumberValidation;

      var sessionToken = this.sessionToken;
      var formCCPaymentPayload = this.formCCPaymentPayload;
      var gcPaymentPayload = this.isAnyGiftCardSelected ? this.gcPaymentPayload : null;
      var creditCardInfo = this.creditCardInfo;
      var card = creditCardInfo.card;
      var cardNumberValidationInfo = creditCardInfo.numberValidationInfo;
      return {
        BIN: Number((_card$cardNumber = card.cardNumber) === null || _card$cardNumber === void 0 ? void 0 : _card$cardNumber.substring(0, 6)),
        last4Digits: Number(card.cardNumber.slice(-4)),
        cardType: cardNumberValidationInfo === null || cardNumberValidationInfo === void 0 ? void 0 : (_cardNumberValidation = cardNumberValidationInfo.card) === null || _cardNumberValidation === void 0 ? void 0 : _cardNumberValidation.type,
        orderId: orderId,
        status: null,
        name: card === null || card === void 0 ? void 0 : card.nameOnCard,
        zipCode: Number(creditCardInfo.zipCode),
        expMonth: Number(card.expMonth),
        expYear: Number(card.expYear),
        savedCard: creditCardInfo.saveCreditCard,
        transactionType: this.flow,
        localTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        referer: this.rootStore.platformUtil.getHostName()
      };
    }
  }, {
    key: "getTokenizationFailureLogRequestRSA",
    value: function getTokenizationFailureLogRequestRSA(orderId, errorCode) {
      var _card$cardNumber2, _cardNumberValidation2;

      var formCCPaymentPayload = this.formCCPaymentPayload;
      var creditCardInfo = this.creditCardInfo;
      var card = creditCardInfo.card;
      var cardNumberValidationInfo = creditCardInfo.numberValidationInfo;
      return {
        BIN: Number((_card$cardNumber2 = card.cardNumber) === null || _card$cardNumber2 === void 0 ? void 0 : _card$cardNumber2.substring(0, 6)),
        last4Digits: Number(card.cardNumber.slice(-4)),
        cardType: cardNumberValidationInfo === null || cardNumberValidationInfo === void 0 ? void 0 : (_cardNumberValidation2 = cardNumberValidationInfo.card) === null || _cardNumberValidation2 === void 0 ? void 0 : _cardNumberValidation2.type,
        zipCode: Number(creditCardInfo.zipCode),
        expMonth: Number(card.expMonth),
        expYear: Number(card.expYear),
        orderId: orderId,
        status: errorCode,
        name: card === null || card === void 0 ? void 0 : card.nameOnCard,
        savedCard: creditCardInfo.saveCreditCard,
        transactionType: this.flow,
        localTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        referer: this.rootStore.platformUtil.getHostName()
      };
    }
  }, {
    key: "resolveStateAndCountryFromZip",
    value: function () {
      var _resolveStateAndCountryFromZip = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var zipCode, country, _this$rootStore7, _this$rootStore7$user, JWT_TOKEN, _yield$common$handle7, _yield$common$handle8, err, resp;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                zipCode = this.creditCardInfo.zipCode;
                country = this.creditCardInfo.country || "US";

                if (!(zipCode && country)) {
                  _context10.next = 13;
                  break;
                }

                _context10.next = 5;
                return (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$user = _this$rootStore7.user) === null || _this$rootStore7$user === void 0 ? void 0 : _this$rootStore7$user.getTokenSilentIfLoggedIn();

              case 5:
                JWT_TOKEN = _context10.sent;
                _context10.next = 8;
                return common.handle(DPServices.Common.getCityStateFromZip({
                  zipCode: zipCode,
                  country: country
                }, JWT_TOKEN));

              case 8:
                _yield$common$handle7 = _context10.sent;
                _yield$common$handle8 = _slicedToArray(_yield$common$handle7, 2);
                err = _yield$common$handle8[0];
                resp = _yield$common$handle8[1];

                if (!err) {
                  this.creditCardInfo.city = resp.city;
                  this.creditCardInfo.state = resp.state;
                }

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function resolveStateAndCountryFromZip() {
        return _resolveStateAndCountryFromZip.apply(this, arguments);
      }

      return resolveStateAndCountryFromZip;
    }()
  }, {
    key: "validateSecurityCode",
    value: function () {
      var _validateSecurityCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(paymentCorrelationId, orderId, sessionTokenSource, savedCreditCard, merchantId) {
        var _this$rootStore8, _this$rootStore8$user;

        var payload, JWT_TOKEN, _yield$common$handle9, _yield$common$handle10, orderRSATokenErr, orderRSATokenResponse, _err$errors2, err, BFaultExists, TFaultExists, orderRSAToken, rsaToken, expirationMonthString, encryptionFields, expiryDate, token, billingAddress, credit, type, account, referenceToken, _payload2, _yield$common$handle11, _yield$common$handle12, payTokenErr, paymentNonce, _this$rootStore9, _this$rootStore9$user, VALIDATE_TOKEN_PAYLOAD, _JWT_TOKEN2, _yield$common$handle13, _yield$common$handle14, validateTokenErr, _err2, _BFaultExists, _TFaultExists;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!this.isOrderSessionRSARetryCountExhausted) {
                  _context11.next = 4;
                  break;
                }

                this.isCCPaymentDisabled = true;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ERROR_MAX_ATTEMPTS_REACHED;

              case 4:
                payload = {
                  transactionType: common.RSATokenTransactionType[sessionTokenSource],
                  retryCount: this.orderSessionRSARetryCount,
                  trackingId: this.trackingIdWRTFlow,
                  paymentCorrelationId: paymentCorrelationId
                };
                _context11.next = 7;
                return (_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$user = _this$rootStore8.user) === null || _this$rootStore8$user === void 0 ? void 0 : _this$rootStore8$user.getTokenSilentIfLoggedIn();

              case 7:
                JWT_TOKEN = _context11.sent;
                _context11.next = 10;
                return common.handle(DPServices.Payment.getRSAToken(payload, JWT_TOKEN));

              case 10:
                _yield$common$handle9 = _context11.sent;
                _yield$common$handle10 = _slicedToArray(_yield$common$handle9, 2);
                orderRSATokenErr = _yield$common$handle10[0];
                orderRSATokenResponse = _yield$common$handle10[1];

                if (!orderRSATokenErr) {
                  _context11.next = 36;
                  break;
                }

                err = orderRSATokenErr; // all the retry attempts are already exhausted by RSAToken API

                this.orderSessionRSARetryCount = 0;

                if (!(((_err$errors2 = err.errors) === null || _err$errors2 === void 0 ? void 0 : _err$errors2.length) > 0)) {
                  _context11.next = 31;
                  break;
                }

                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                BFaultExists = err.errors.some(function (errorObj) {
                  return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.code) === "BFAULT";
                });
                TFaultExists = err.errors.some(function (errorObj) {
                  return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.code) === "TFAULT";
                });

                if (!BFaultExists) {
                  _context11.next = 26;
                  break;
                }

                throw common.ERRORS.ERROR_MAX_ATTEMPTS_REACHED;

              case 26:
                if (!TFaultExists) {
                  _context11.next = 28;
                  break;
                }

                throw common.ERRORS.ERROR_SESSION_TOKEN_FAILURE;

              case 28:
                throw common.ERRORS.ERROR_TOKEN_UNKNOWN_FAULT_CASE;

              case 31:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ERROR_SESSION_TOKEN_FAILURE;

              case 34:
                _context11.next = 40;
                break;

              case 36:
                orderRSAToken = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.rsaData;
                this.orderSessionRSARetryCount = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.retryRemaining;
                this.isCCPaymentDisabled = false;
                this.rsaToken = orderRSAToken;

              case 40:
                rsaToken = this.rsaToken;

                if (!(rsaToken && rsaToken.publicKey && rsaToken.tokenId)) {
                  _context11.next = 101;
                  break;
                }

                expirationMonthString = (savedCreditCard === null || savedCreditCard === void 0 ? void 0 : savedCreditCard.expirationMonth) < 10 ? "0".concat(savedCreditCard.expirationMonth) : savedCreditCard.expirationMonth.toString();
                encryptionFields = {
                  securityCode: savedCreditCard.paymentCVV,
                  paymentCardToken: savedCreditCard.paymentCardToken,
                  expirationMonth: expirationMonthString,
                  expirationYear: savedCreditCard.expirationYear.toString()
                };
                _context11.next = 46;
                return common.handle(encryptAccount(encryptionFields, rsaToken));

              case 46:
                // Assemble Payload for PaymentNonceRequestRSA
                expiryDate = {
                  year: encryptionFields.expirationYear,
                  month: encryptionFields.expirationMonth
                };
                token = {
                  tokenProvider: "TRANS_ARMOR",
                  tokenId: encryptionFields.paymentCardToken
                }; // Full AVS validation for saved card

                billingAddress = {
                  postalCode: savedCreditCard.billingAddress.postalCode.toString(),
                  locality: savedCreditCard.billingAddress.city,
                  region: savedCreditCard.billingAddress.state,
                  country: savedCreditCard.billingAddress.country,
                  streetAddress: savedCreditCard.billingAddress.address1
                };
                credit = {
                  securityCode: encryptionFields.securityCode,
                  cardType: savedCreditCard.creditCardType,
                  token: token,
                  expiryDate: expiryDate,
                  billingAddress: billingAddress
                };
                type = "CREDIT";
                account = {
                  type: type,
                  credit: credit
                };
                referenceToken = {
                  tokenType: "CLAIM_CHECK_NONCE"
                };
                _payload2 = {
                  merchantId: merchantId,
                  account: account,
                  referenceToken: referenceToken
                };
                _context11.next = 56;
                return common.handle(DPServices.Payment.getPaymentNonceRSA(rsaToken, _payload2));

              case 56:
                _yield$common$handle11 = _context11.sent;
                _yield$common$handle12 = _slicedToArray(_yield$common$handle11, 2);
                payTokenErr = _yield$common$handle12[0];
                paymentNonce = _yield$common$handle12[1];

                if (!(paymentNonce && paymentNonce.paymentNonce && !payTokenErr)) {
                  _context11.next = 97;
                  break;
                }

                VALIDATE_TOKEN_PAYLOAD = {
                  nonce: paymentNonce.paymentNonce,
                  token: savedCreditCard.paymentCardToken,
                  tokenId: rsaToken.tokenId,
                  tokenProvider: paymentNonce.provider,
                  tokenType: "CLAIM_CHECK_NONCE",
                  transactionType: common.ValidateTokenTransactionType[sessionTokenSource],
                  trackingId: this.trackingIdWRTFlow
                };
                _context11.next = 64;
                return (_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$user = _this$rootStore9.user) === null || _this$rootStore9$user === void 0 ? void 0 : _this$rootStore9$user.getTokenSilentIfLoggedIn();

              case 64:
                _JWT_TOKEN2 = _context11.sent;
                _context11.next = 67;
                return common.handle(DPServices.Payment.validateToken(VALIDATE_TOKEN_PAYLOAD, _JWT_TOKEN2));

              case 67:
                _yield$common$handle13 = _context11.sent;
                _yield$common$handle14 = _slicedToArray(_yield$common$handle13, 1);
                validateTokenErr = _yield$common$handle14[0];

                if (!validateTokenErr) {
                  _context11.next = 94;
                  break;
                }

                this.orderSessionRSARetryCount = this.orderSessionRSARetryCount - 1;
                _err2 = validateTokenErr;

                if (!(_err2.errors.length > 0)) {
                  _context11.next = 89;
                  break;
                }

                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                _BFaultExists = _err2.errors.some(function (errorObj) {
                  return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.code) === "BFAULT";
                });
                _TFaultExists = _err2.errors.some(function (errorObj) {
                  return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.code) === "TFAULT";
                });

                if (!_BFaultExists) {
                  _context11.next = 82;
                  break;
                }

                throw common.ERRORS.ERROR_MAX_ATTEMPTS_REACHED;

              case 82:
                if (!_TFaultExists) {
                  _context11.next = 86;
                  break;
                }

                throw common.ERRORS.ERROR_SESSION_TOKEN_FAILURE;

              case 86:
                throw common.ERRORS.ERROR_TOKEN_UNKNOWN_FAULT_CASE;

              case 87:
                _context11.next = 92;
                break;

              case 89:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.CVV_VALIDATION_ERROR;

              case 92:
                _context11.next = 95;
                break;

              case 94:
                this.isCCPaymentDisabled = false;

              case 95:
                _context11.next = 99;
                break;

              case 97:
                // Only technical faults possbile for Nonce generation
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                throw common.ERRORS.CC_TOKENIZATION_TECHNICAL_FAILURE;

              case 99:
                _context11.next = 104;
                break;

              case 101:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ERROR_SESSION_TOKEN_FAILURE;

              case 104:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function validateSecurityCode(_x12, _x13, _x14, _x15, _x16) {
        return _validateSecurityCode.apply(this, arguments);
      }

      return validateSecurityCode;
    }()
  }, {
    key: "tokenizePayPal",
    value: function () {
      var _tokenizePayPal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(payload, deviceData) {
        var resp;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return DPServices.Payment.tokenizePayPal(payload.details.payerId, payload.nonce, deviceData.correlation_id);

              case 2:
                resp = _context12.sent;
                this.payPalData = {
                  tokenData: resp,
                  approvalData: payload,
                  deviceData: deviceData
                };

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function tokenizePayPal(_x17, _x18) {
        return _tokenizePayPal.apply(this, arguments);
      }

      return tokenizePayPal;
    }()
  }, {
    key: "tokenizePayPalRSA",
    value: function () {
      var _tokenizePayPalRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(paymentCorrelationId, payload, deviceData, merchantId, transactionType) {
        var _this$rootStore10, _this$rootStore10$use;

        var rsaPayload, JWT_TOKEN, _yield$common$handle15, _yield$common$handle16, orderRSATokenErr, orderRSATokenResponse, _err$errors3, err, BFaultExists, TFaultExists, orderRSAToken, payPalRSA, payPalAccountRSA, tokenPayPal, payloadRSA, resp;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                rsaPayload = {
                  transactionType: common.RSATokenTransactionType[transactionType],
                  retryCount: this.orderSessionRSARetryCount,
                  trackingId: this.trackingIdWRTFlow,
                  paymentCorrelationId: paymentCorrelationId
                };
                _context13.next = 3;
                return (_this$rootStore10 = this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$use = _this$rootStore10.user) === null || _this$rootStore10$use === void 0 ? void 0 : _this$rootStore10$use.getTokenSilentIfLoggedIn();

              case 3:
                JWT_TOKEN = _context13.sent;
                _context13.next = 6;
                return common.handle(DPServices.Payment.getRSAToken(rsaPayload, JWT_TOKEN));

              case 6:
                _yield$common$handle15 = _context13.sent;
                _yield$common$handle16 = _slicedToArray(_yield$common$handle15, 2);
                orderRSATokenErr = _yield$common$handle16[0];
                orderRSATokenResponse = _yield$common$handle16[1];

                if (!orderRSATokenErr) {
                  _context13.next = 34;
                  break;
                }

                err = orderRSATokenErr; // all the retry attempts are already exhausted by RSAToken API

                this.orderSessionRSARetryCount = 0;

                if (!(((_err$errors3 = err.errors) === null || _err$errors3 === void 0 ? void 0 : _err$errors3.length) > 0)) {
                  _context13.next = 29;
                  break;
                }

                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                BFaultExists = err.errors.some(function (errorObj) {
                  return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.code) === "BFAULT";
                });
                TFaultExists = err.errors.some(function (errorObj) {
                  return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.code) === "TFAULT";
                });

                if (!BFaultExists) {
                  _context13.next = 22;
                  break;
                }

                throw common.ERRORS.ERROR_MAX_ATTEMPTS_REACHED;

              case 22:
                if (!TFaultExists) {
                  _context13.next = 26;
                  break;
                }

                throw common.ERRORS.ERROR_SESSION_TOKEN_FAILURE;

              case 26:
                throw common.ERRORS.ERROR_TOKEN_UNKNOWN_FAULT_CASE;

              case 27:
                _context13.next = 32;
                break;

              case 29:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ERROR_SESSION_TOKEN_FAILURE;

              case 32:
                _context13.next = 37;
                break;

              case 34:
                orderRSAToken = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.rsaData;
                this.orderSessionRSARetryCount = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.retryRemaining;
                this.rsaToken = orderRSAToken;

              case 37:
                payPalRSA = {
                  payerId: payload.details.payerId,
                  nonce: payload.nonce
                };
                payPalAccountRSA = {
                  type: "PAYPAL",
                  paypal: payPalRSA
                };
                tokenPayPal = {
                  tokenProvider: "TRANS_ARMOR",
                  tokenType: "FORMAT_PRESERVING_MULTI_USE"
                };
                payloadRSA = {
                  merchantId: merchantId,
                  account: payPalAccountRSA,
                  token: tokenPayPal
                };
                resp = DPServices.Payment.getPayPalTokenRSA(this.rsaToken, payloadRSA);
                _context13.next = 44;
                return resp;

              case 44:
                _context13.t0 = _context13.sent;
                _context13.t1 = payload;
                _context13.t2 = deviceData;
                this.payPalData = {
                  tokenData: _context13.t0,
                  approvalData: _context13.t1,
                  deviceData: _context13.t2
                };

              case 48:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function tokenizePayPalRSA(_x19, _x20, _x21, _x22, _x23) {
        return _tokenizePayPalRSA.apply(this, arguments);
      }

      return tokenizePayPalRSA;
    }()
  }, {
    key: "prepareEditCreditCardValidationPayload",
    value: function prepareEditCreditCardValidationPayload() {
      var creditCardInfoModel = this.creditCardInfo;
      var expiry = creditCardInfoModel.expiry,
          firstName = creditCardInfoModel.firstName,
          lastName = creditCardInfoModel.lastName,
          billingAddress = creditCardInfoModel.billingAddress,
          savedCardPaymentToken = creditCardInfoModel.savedCardPaymentToken,
          savedCardType = creditCardInfoModel.savedCardType,
          cvv = creditCardInfoModel.cvv;
      var expiryParts = expiry.split("/");
      var expirationMonth = expiryParts[0];
      var expirationYear = expiryParts[1];
      var creditCard = {
        amount: 0,
        tipAmount: 0,
        paymentCardToken: savedCardPaymentToken,
        creditCardType: savedCardType,
        expirationMonth: Number(expirationMonth),
        expirationYear: Number(expirationYear),
        cardAlias: Number(savedCardPaymentToken.slice(-4)),
        billingAddress: _objectSpread(_objectSpread({
          firstName: firstName,
          lastName: lastName
        }, billingAddress), {}, {
          postalCode: billingAddress.postalCode
        }),
        paymentCVV: cvv,
        acceptClientType: this.rootStore.acceptClientType,
        cardOnFile: true,
        isDefault: creditCardInfoModel.isDefault,
        saveCardToProfile: true
      };
      return creditCard;
    }
  }, {
    key: "prepareSaveEditCreditCardPayload",
    value: function () {
      var _prepareSaveEditCreditCardPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(actionOnCard) {
        var jwtToken, merchantId, paymentCorrelationId, _payload3, errorDescription, creditCardInfoModel, expiryParts, expirationMonth, expirationYear, payload;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.rootStore.user.getTokenSilentIfLoggedIn();

              case 2:
                jwtToken = _context14.sent;
                merchantId = this.creditCardInfo.fullAVSEnabled ? this._appAttributes.fullAVSmerchantID : this._appAttributes.partialAVSmerchantID;
                paymentCorrelationId = this._appAttributes.paymentCorrelationId;
                _context14.prev = 5;

                if (!(actionOnCard === "Save")) {
                  _context14.next = 11;
                  break;
                }

                _context14.next = 9;
                return this.tokenizeCreditCardPaymentRSA(paymentCorrelationId, "", merchantId, "PROFILE");

              case 9:
                _context14.next = 14;
                break;

              case 11:
                _payload3 = this.prepareEditCreditCardValidationPayload();
                _context14.next = 14;
                return this.validateSecurityCode(paymentCorrelationId, "", "PROFILE", _payload3, merchantId);

              case 14:
                _context14.next = 21;
                break;

              case 16:
                _context14.prev = 16;
                _context14.t0 = _context14["catch"](5);
                errorDescription = DPServices.Common.checkAndGetErrorDescription(_context14.t0) || Errors.SAVE_CREDIT_CARD_TO_PROFILE_FAILED;
                this.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription.message);
                throw errorDescription;

              case 21:
                creditCardInfoModel = this.creditCardInfo;
                expiryParts = creditCardInfoModel.expiry.split("/");
                expirationMonth = expiryParts[0];
                expirationYear = expiryParts[1];
                payload = {
                  creditCard: {
                    acceptClientType: "app-profile-addcard",
                    isDefault: creditCardInfoModel.isDefault,
                    creditCardType: actionOnCard === "Save" ? creditCardInfoModel.paymentToken.cardType : creditCardInfoModel.savedCardType,
                    expirationMonth: expirationMonth,
                    expirationYear: expirationYear,
                    paymentCardToken: actionOnCard === "Save" ? creditCardInfoModel.paymentToken.paymentToken : creditCardInfoModel.savedCardPaymentToken,
                    billingAddress: {
                      address1: creditCardInfoModel.addressLine1,
                      address2: creditCardInfoModel.addressLine2,
                      city: creditCardInfoModel.city,
                      country: creditCardInfoModel.country,
                      firstName: creditCardInfoModel.firstName,
                      lastName: creditCardInfoModel.lastName,
                      postalCode: creditCardInfoModel.zipCode,
                      state: creditCardInfoModel.state
                    }
                  }
                };
                return _context14.abrupt("return", payload);

              case 27:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[5, 16]]);
      }));

      function prepareSaveEditCreditCardPayload(_x24) {
        return _prepareSaveEditCreditCardPayload.apply(this, arguments);
      }

      return prepareSaveEditCreditCardPayload;
    }()
  }, {
    key: "saveCreditCardToProfile",
    value: function () {
      var _saveCreditCardToProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _this$rootStore11, _this$rootStore11$pla, payload, JWT_TOKEN, saveCreditCardsResponse, errorUI;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return this.prepareSaveEditCreditCardPayload("Save");

              case 3:
                payload = _context15.sent;
                _context15.next = 6;
                return this.rootStore.user.ensureAuth();

              case 6:
                JWT_TOKEN = _context15.sent;
                _context15.next = 9;
                return DPServices.Payment.saveCreditCard(JWT_TOKEN, payload);

              case 9:
                saveCreditCardsResponse = _context15.sent;
                (_this$rootStore11 = this.rootStore) === null || _this$rootStore11 === void 0 ? void 0 : (_this$rootStore11$pla = _this$rootStore11.platformUtil) === null || _this$rootStore11$pla === void 0 ? void 0 : _this$rootStore11$pla.dispatchEvent("AnalyticsEvent", "gift card added", {});
                this.creditCardInfo.resetCreditCardModel();
                this.setCreditCards(saveCreditCardsResponse.creditCards);
                this.isCCLimitExceeded = saveCreditCardsResponse.isCCLimitExceeded;
                _context15.next = 21;
                break;

              case 16:
                _context15.prev = 16;
                _context15.t0 = _context15["catch"](0);
                this.creditCardInfo.resetCreditCardFormFlow();
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context15.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.SAVE_CREDIT_CARD_TO_PROFILE_FAILED.message
                });
                this.rootStore.appMessages.showError(errorUI.title, errorUI.message, null, {
                  undismissible: true,
                  okBtnText: "Okay"
                });

              case 21:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 16]]);
      }));

      function saveCreditCardToProfile() {
        return _saveCreditCardToProfile.apply(this, arguments);
      }

      return saveCreditCardToProfile;
    }()
  }, {
    key: "updateCreditCardAndSaveToUserProfile",
    value: function () {
      var _updateCreditCardAndSaveToUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var payload, JWT_TOKEN, updatedCreditCardsResponse, errorUI;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return this.prepareSaveEditCreditCardPayload("Update");

              case 3:
                payload = _context16.sent;
                _context16.next = 6;
                return this.rootStore.user.ensureAuth();

              case 6:
                JWT_TOKEN = _context16.sent;
                _context16.next = 9;
                return DPServices.Payment.saveCreditCard(JWT_TOKEN, payload);

              case 9:
                updatedCreditCardsResponse = _context16.sent;
                this.creditCardInfo.resetCreditCardModel();
                this.setCreditCards(updatedCreditCardsResponse.creditCards);
                this.isCCLimitExceeded = updatedCreditCardsResponse.isCCLimitExceeded;
                _context16.next = 20;
                break;

              case 15:
                _context16.prev = 15;
                _context16.t0 = _context16["catch"](0);
                this.creditCardInfo.resetCreditCardFormFlow();
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context16.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.UPDATE_CREDIT_CARD_AND_SAVE_TO_PROFILE_FAILED.message
                });
                this.rootStore.appMessages.showError(errorUI.title, errorUI.message, null, {
                  undismissible: true,
                  okBtnText: "Okay"
                });

              case 20:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 15]]);
      }));

      function updateCreditCardAndSaveToUserProfile() {
        return _updateCreditCardAndSaveToUserProfile.apply(this, arguments);
      }

      return updateCreditCardAndSaveToUserProfile;
    }()
  }, {
    key: "deleteCreditCardFromUserProfile",
    value: function () {
      var _deleteCreditCardFromUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(cardDetails) {
        var payload, JWT_TOKEN, response, errorUI;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                payload = {
                  paymentCardToken: this.creditCards[cardDetails.cardIndex].card.paymentCardToken
                };
                _context17.next = 4;
                return this.rootStore.user.ensureAuth();

              case 4:
                JWT_TOKEN = _context17.sent;
                _context17.next = 7;
                return DPServices.Payment.deleteCreditCard(JWT_TOKEN, payload);

              case 7:
                response = _context17.sent;
                this.setCreditCards(response.creditCards);
                this.isCCLimitExceeded = response.isCCLimitExceeded;
                _context17.next = 17;
                break;

              case 12:
                _context17.prev = 12;
                _context17.t0 = _context17["catch"](0);
                this.creditCardInfo.resetCreditCardFormFlow();
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context17.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.DELETE_CREDIT_CARD_FROM_USER_PROFILE.message
                });
                this.rootStore.appMessages.showError(errorUI.title, errorUI.message, null, {
                  undismissible: true,
                  okBtnText: "Okay"
                });

              case 17:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 12]]);
      }));

      function deleteCreditCardFromUserProfile(_x25) {
        return _deleteCreditCardFromUserProfile.apply(this, arguments);
      }

      return deleteCreditCardFromUserProfile;
    }()
  }, {
    key: "deleteGiftCard",
    value: function () {
      var _deleteGiftCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var JWT_TOKEN, updatedGiftCardsResponse, errorUI;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                this.giftCardInfo.isRefreshingBalance = true;
                _context18.next = 4;
                return this.rootStore.user.ensureAuth();

              case 4:
                JWT_TOKEN = _context18.sent;
                _context18.next = 7;
                return DPServices.Payment.deleteGiftCard(JWT_TOKEN, {
                  giftCardInfoId: this.giftCardInfo.giftCardToDelete.id
                });

              case 7:
                updatedGiftCardsResponse = _context18.sent;
                this.setGiftCards(updatedGiftCardsResponse === null || updatedGiftCardsResponse === void 0 ? void 0 : updatedGiftCardsResponse.giftCards);
                this.isGCLimitExceeded = updatedGiftCardsResponse === null || updatedGiftCardsResponse === void 0 ? void 0 : updatedGiftCardsResponse.isGCLimitExceeded;
                this.giftCardInfo.isRefreshingBalance = false;
                _context18.next = 18;
                break;

              case 13:
                _context18.prev = 13;
                _context18.t0 = _context18["catch"](0);
                this.giftCardInfo.isRefreshingBalance = false;
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context18.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.DELETE_GIFT_CARD.message
                });
                this.rootStore.appMessages.showError(errorUI.title, errorUI.message, null, {
                  undismissible: true,
                  okBtnText: "Okay"
                });

              case 18:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 13]]);
      }));

      function deleteGiftCard() {
        return _deleteGiftCard.apply(this, arguments);
      }

      return deleteGiftCard;
    }()
  }, {
    key: "updateCityStateCountryFromZip",
    value: function updateCityStateCountryFromZip() {
      var creditCardInfoModel = this.creditCardInfo;

      if (creditCardInfoModel.checkIfZipValid && creditCardInfoModel.fullAVSEnabled) {
        this.resolveStateAndCountryFromZip();
      } else {
        var validCountries = common.COUNTRIES.filter(function (item) {
          return common.isZipValid(creditCardInfoModel === null || creditCardInfoModel === void 0 ? void 0 : creditCardInfoModel.zipCode, item.code);
        });

        if (validCountries.length) {
          creditCardInfoModel.country = validCountries[0].code;

          if (creditCardInfoModel.fullAVSEnabled) {
            this.resolveStateAndCountryFromZip();
          }
        }
      }
    }
  }, {
    key: "setShowError",
    value: function setShowError(val) {
      this._showError = val;
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(price) {
      var _BrandRules, _this$_appAttributes;

      var pricingFormat = (_BrandRules = new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.pricingFormat();

      switch (pricingFormat) {
        case "$xx":
          return "$".concat(price.toFixed(0));

        case "$xx.xx":
          return "$".concat(price.toFixed(2));

        case "xx":
          return "".concat(price.toFixed(0));

        case "xx.xx":
          return "".concat(price.toFixed(2));

        case "s52":
          return "".concat(Number(price.toFixed(2)));

        default:
          return "$".concat(price.toFixed(2));
      }
    }
  }, {
    key: "showFormattedPrice",
    value: function showFormattedPrice(num) {
      var finalResult;

      if (num === undefined || num === null || num === "") {
        return "";
      } else if (typeof num === "string") {
        if (num.length <= 0) return "";
        var res = num.replace(/[^\d.]/g, "");
        var b = num.replace(/[\d.]/g, "").replace("$", "");
        finalResult = b + this.formatPrice(Number(res));
      } else {
        finalResult = this.formatPrice(num);
      }

      return finalResult.toString();
    }
  }, {
    key: "setDefaultCreditCard",
    value: function setDefaultCreditCard(creditCards) {
      var _creditCards$filter;

      var defaultSavedCard = creditCards === null || creditCards === void 0 ? void 0 : (_creditCards$filter = creditCards.filter(function (card) {
        return card.isDefault;
      })) === null || _creditCards$filter === void 0 ? void 0 : _creditCards$filter[0];

      if (defaultSavedCard) {
        this.selectCreditCard({
          card: defaultSavedCard,
          isSelected: true,
          isDisabled: false,
          isVisible: true,
          proratedTip: 0,
          proratedAmount: 0,
          paymentCVV: null,
          hasExpired: false,
          isDefault: true
        });
      }
    }
  }, {
    key: "fetchAndUpdatePaymentMethods",
    value: function () {
      var _fetchAndUpdatePaymentMethods = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var JWT_TOKEN, paymentMethods, errorUI;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;

                if (this.rootStore.user.isLoggedIn) {
                  _context19.next = 3;
                  break;
                }

                return _context19.abrupt("return");

              case 3:
                _context19.next = 5;
                return this.rootStore.user.ensureAuth();

              case 5:
                JWT_TOKEN = _context19.sent;
                _context19.next = 8;
                return DPServices.Payment.getPaymentMethods(JWT_TOKEN);

              case 8:
                paymentMethods = _context19.sent;
                this.setCreditCards(paymentMethods.creditCards);
                this.setGiftCards(paymentMethods.giftCards);
                this.isGCLimitExceeded = paymentMethods.isGCLimitExceeded;
                this.isCCLimitExceeded = paymentMethods.isCCLimitExceeded;
                this.setDefaultCreditCard(paymentMethods.creditCards);
                _context19.next = 20;
                break;

              case 16:
                _context19.prev = 16;
                _context19.t0 = _context19["catch"](0);
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context19.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.GET_PAYMENT_METHODS_FAILED.message
                });
                this.rootStore.appMessages.showError(errorUI.title, errorUI.message, null, {
                  undismissible: true,
                  okBtnText: "Okay"
                });

              case 20:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 16]]);
      }));

      function fetchAndUpdatePaymentMethods() {
        return _fetchAndUpdatePaymentMethods.apply(this, arguments);
      }

      return fetchAndUpdatePaymentMethods;
    }()
  }, {
    key: "fetchAndUpdateGiftCards",
    value: function () {
      var _fetchAndUpdateGiftCards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var JWT_TOKEN, giftCardsResponse, errorUI;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                this.giftCardInfo.isRefreshingBalance = true;
                _context20.next = 4;
                return this.rootStore.user.ensureAuth();

              case 4:
                JWT_TOKEN = _context20.sent;
                _context20.next = 7;
                return DPServices.Payment.getGiftCards(JWT_TOKEN);

              case 7:
                giftCardsResponse = _context20.sent;
                this.setGiftCards(giftCardsResponse.giftCards);
                this.isGCLimitExceeded = giftCardsResponse.isGCLimitExceeded;
                this.giftCardInfo.isRefreshingBalance = false;
                _context20.next = 18;
                break;

              case 13:
                _context20.prev = 13;
                _context20.t0 = _context20["catch"](0);
                this.giftCardInfo.isRefreshingBalance = false;
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context20.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.GET_GIFT_CARDS_FAILED.message
                });
                this.rootStore.appMessages.showError(errorUI.title, errorUI.message, null, {
                  undismissible: true,
                  okBtnText: "Okay"
                });

              case 18:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[0, 13]]);
      }));

      function fetchAndUpdateGiftCards() {
        return _fetchAndUpdateGiftCards.apply(this, arguments);
      }

      return fetchAndUpdateGiftCards;
    }()
  }, {
    key: "fetchAndUpdateCreditCards",
    value: function () {
      var _fetchAndUpdateCreditCards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var JWT_TOKEN, creditCardsResponse, errorUI;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                _context21.next = 3;
                return this.rootStore.user.ensureAuth();

              case 3:
                JWT_TOKEN = _context21.sent;
                _context21.next = 6;
                return DPServices.Payment.getCreditCards(JWT_TOKEN);

              case 6:
                creditCardsResponse = _context21.sent;
                this.setCreditCards(creditCardsResponse.creditCards);
                this.isCCLimitExceeded = creditCardsResponse.isCCLimitExceeded;
                this.setDefaultCreditCard(creditCardsResponse.creditCards);
                _context21.next = 16;
                break;

              case 12:
                _context21.prev = 12;
                _context21.t0 = _context21["catch"](0);
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context21.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.GET_CREDIT_CARDS_FAILED.message
                });
                this.rootStore.appMessages.showError(errorUI.title, errorUI.message, null, {
                  undismissible: true,
                  okBtnText: "Okay"
                });

              case 16:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[0, 12]]);
      }));

      function fetchAndUpdateCreditCards() {
        return _fetchAndUpdateCreditCards.apply(this, arguments);
      }

      return fetchAndUpdateCreditCards;
    }()
  }, {
    key: "activePaymentTab",
    get: function get() {
      return this._activePaymentTab;
    },
    set: function set(_activePaymentTab) {
      var _this10 = this;

      runInAction(function () {
        _this10._activePaymentTab = _activePaymentTab;
      });
    }
  }, {
    key: "flow",
    get: function get() {
      return this._flow;
    },
    set: function set(val) {
      var _this11 = this;

      runInAction(function () {
        _this11._flow = val;
      });
    }
  }, {
    key: "paymentCVVEnabled",
    get: function get() {
      return this._paymentCVVEnabled;
    },
    set: function set(paymentCVVEnabled) {
      var _this12 = this;

      runInAction(function () {
        _this12._paymentCVVEnabled = paymentCVVEnabled;
      });
    }
  }, {
    key: "requestPhoneNumberFromAppleOrGooglePay",
    get: function get() {
      return this._requestPhoneNumberFromAppleOrGooglePay;
    },
    set: function set(requestPhoneNumberFromAppleOrGooglePay) {
      var _this13 = this;

      runInAction(function () {
        _this13._requestPhoneNumberFromAppleOrGooglePay = requestPhoneNumberFromAppleOrGooglePay;
      });
    }
  }, {
    key: "requestShippingFieldsFromAppleOrGooglePay",
    get: function get() {
      return this._requestShippingFieldsFromAppleOrGooglePay;
    },
    set: function set(requestShippingFieldsFromAppleOrGooglePay) {
      var _this14 = this;

      runInAction(function () {
        _this14._requestShippingFieldsFromAppleOrGooglePay = requestShippingFieldsFromAppleOrGooglePay;
      });
    }
  }, {
    key: "formSubmitted",
    get: function get() {
      return this._formSubmitted;
    },
    set: function set(val) {
      var _this15 = this;

      runInAction(function () {
        _this15._formSubmitted = val;
      });
    }
  }, {
    key: "activeOtherOptionTab",
    get: function get() {
      if (this.activePaymentTab === utils.PaymentMethods.PAY_AT_RESTAURANT || this.isSavedCreditCardSelected) {
        return utils.OnlinePaymentTypes.NONE;
      }

      return this.toPay > 0 ? this._activeOtherOptionTab : utils.OnlinePaymentTypes.NONE;
    },
    set: function set(activeOtherOptionTab) {
      var _this16 = this;

      runInAction(function () {
        _this16._activeOtherOptionTab = activeOtherOptionTab;
      });

      if (activeOtherOptionTab !== utils.OnlinePaymentTypes.NONE) {
        this.deSelectCreditCards();
      }
    }
  }, {
    key: "paymentCVV",
    get: function get() {
      return this._paymentCVV;
    },
    set: function set(val) {
      var _this17 = this;

      runInAction(function () {
        _this17._paymentCVV = val;
      });
    }
  }, {
    key: "smartPayOptionsEnabled",
    get: function get() {
      return this.isPayPalEnabled || this.isGooglePayEnabled || this.isApplePayEnabled;
    }
  }, {
    key: "allowedPaymentMethods",
    get: function get() {
      return this._allowedPaymentMethods;
    },
    set: function set(val) {
      var _this18 = this;

      runInAction(function () {
        _this18._allowedPaymentMethods = val;

        if (val === "PAY_REST") {
          _this18._activePaymentTab = utils.PaymentMethods.PAY_AT_RESTAURANT;
        } else {
          _this18._activePaymentTab = utils.PaymentMethods.ONLINE;
        }
      });
    }
  }, {
    key: "onlinePaymentsOrder",
    get: function get() {
      var paymentTypes = [utils.OnlinePaymentTypes.CREDIT_CARD];

      if (this.isPayPalEnabled) {
        paymentTypes.push(utils.OnlinePaymentTypes.PAYPAL);
      }

      if (this.isApplePayEnabled) {
        paymentTypes.push(utils.OnlinePaymentTypes.APPLE_PAY);
      }

      if (this.isGooglePayEnabled) {
        paymentTypes.push(utils.OnlinePaymentTypes.GOOGLE_PAY);
      }

      return paymentTypes;
    }
  }, {
    key: "isCCPaymentDisabled",
    get: function get() {
      return this._isCCPaymentDisabled;
    },
    set: function set(isCCPaymentDisabled) {
      var _this19 = this;

      runInAction(function () {
        _this19._isCCPaymentDisabled = isCCPaymentDisabled;
      });
    }
  }, {
    key: "orderPriceInfo",
    get: function get() {
      return this._orderPriceInfo;
    },
    set: function set(val) {
      var _this20 = this;

      runInAction(function () {
        _this20._orderPriceInfo = val;
      });
    }
  }, {
    key: "tippableAmount",
    get: function get() {
      return this._tippableAmount;
    },
    set: function set(val) {
      var _this21 = this;

      runInAction(function () {
        _this21._tippableAmount = val;

        if (val <= 0) {
          _this21.gratuityModel.addGratuity = false;
          _this21.gratuityModel.selectedTipPercentage = 0;
        }
      });
    }
  }, {
    key: "subTotalWithoutItemDiscount",
    get: function get() {
      return this._subTotalWithoutItemDiscount;
    },
    set: function set(val) {
      var _this22 = this;

      runInAction(function () {
        _this22._subTotalWithoutItemDiscount = val;
      });
    }
  }, {
    key: "sessionToken",
    get: function get() {
      return this._sessionToken;
    },
    set: function set(val) {
      var _this23 = this;

      runInAction(function () {
        _this23._sessionToken = val;
      });
    }
  }, {
    key: "rsaToken",
    get: function get() {
      return this._rsaToken;
    },
    set: function set(val) {
      var _this24 = this;

      runInAction(function () {
        _this24._rsaToken = val;
      });
    }
  }, {
    key: "encryptionFields",
    get: function get() {
      return this._encryptionFields;
    },
    set: function set(val) {
      var _this25 = this;

      runInAction(function () {
        _this25._encryptionFields = val;
      });
    }
  }, {
    key: "payPalData",
    get: function get() {
      return this._payPalData;
    },
    set: function set(val) {
      var _this26 = this;

      runInAction(function () {
        _this26._payPalData = val;
      });
    }
  }, {
    key: "isMobilePayFlowActive",
    get: function get() {
      return [utils.PaymentFlow.MPAY_CLQ, utils.PaymentFlow.MPAY_OPCIO, utils.PaymentFlow.MPAY_TLQ].includes(this._flow);
    }
  }, {
    key: "componentRef",
    get: function get() {
      return this._componentRef;
    },
    set: function set(_componentRef) {
      var _this27 = this;

      runInAction(function () {
        _this27._componentRef = _componentRef;
      });
    }
  }, {
    key: "savedGiftCardsLimit",
    get: function get() {
      return this._savedGiftCardsLimit;
    },
    set: function set(savedGiftCardsLimit) {
      var _this28 = this;

      runInAction(function () {
        _this28._savedGiftCardsLimit = savedGiftCardsLimit;
      });
    }
  }, {
    key: "maximumGCAllowedPerOrder",
    get: function get() {
      var _this$rootStore12, _this$rootStore12$com, _this$rootStore12$com2;

      var appConfig = (_this$rootStore12 = this.rootStore) === null || _this$rootStore12 === void 0 ? void 0 : (_this$rootStore12$com = _this$rootStore12.common) === null || _this$rootStore12$com === void 0 ? void 0 : (_this$rootStore12$com2 = _this$rootStore12$com.appAttributes) === null || _this$rootStore12$com2 === void 0 ? void 0 : _this$rootStore12$com2.configs;

      if (this.flow === utils.PaymentFlow.MPAY_CLQ || this.flow === utils.PaymentFlow.MPAY_TLQ) {
        return parseInt(appConfig !== null && appConfig !== void 0 && appConfig.maximumGCAllowedPerCheck ? appConfig.maximumGCAllowedPerCheck : "1");
      } else return parseInt(appConfig !== null && appConfig !== void 0 && appConfig.maximumGCAllowedPerOrder ? appConfig.maximumGCAllowedPerOrder : "3");
    },
    set: function set(maximumGCAllowedPerOrder) {
      var _this29 = this;

      runInAction(function () {
        _this29._maximumGCAllowedPerOrder = maximumGCAllowedPerOrder;
      });
    }
  }, {
    key: "gratuity",
    get: function get() {
      if (this.isPayAtRest) return 0;
      var selectedTipPercentage = this.gratuityModel.selectedTipPercentage;
      var tipAmount = this.gratuityModel.tipAmount;
      var showCustomAmount = this.gratuityModel.showCustomAmount;
      var gratuityAmount = showCustomAmount ? tipAmount : this.tippableAmount * selectedTipPercentage * 0.01;
      return gratuityAmount ? common.roundTo(gratuityAmount, 2) : 0.0;
    }
  }, {
    key: "userProfile",
    get: function get() {
      return this._userProfile;
    },
    set: function set(profile) {
      var _this30 = this;

      runInAction(function () {
        _this30._userProfile = profile;
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      if (this.activePaymentTab === utils.PaymentMethods.PAY_AT_RESTAURANT) {
        return true;
      }

      if (this.isSavedCreditCardSelected) {
        if (this.paymentCVVEnabled) {
          var _this$selectedCreditC;

          var creditCardInfo = common.getCardTypeInfo(this.selectedCreditCard.card.creditCardType);
          return !!((_this$selectedCreditC = this.selectedCreditCard) !== null && _this$selectedCreditC !== void 0 && _this$selectedCreditC.paymentCVV) && this.selectedCreditCard.paymentCVV.length === creditCardInfo.code.size;
        } else {
          return true;
        }
      } else if (this.isSelectedGiftCardsSufficient) {
        return true;
      } else if (this.creditCardInfo.isValid) {
        return true;
      } else if (this.activeOtherOptionTab === utils.OnlinePaymentTypes.PAYPAL || this.activeOtherOptionTab === utils.OnlinePaymentTypes.APPLE_PAY || this.activeOtherOptionTab === utils.OnlinePaymentTypes.GOOGLE_PAY) {
        return true;
      }

      return false;
    }
  }, {
    key: "giftCards",
    get: function get() {
      if (this.activePaymentTab === utils.PaymentMethods.PAY_AT_RESTAURANT) {
        var _this$_giftCards;

        return (_this$_giftCards = this._giftCards) === null || _this$_giftCards === void 0 ? void 0 : _this$_giftCards.map(function (giftCard) {
          return _objectSpread(_objectSpread({}, giftCard), {}, {
            isSelected: false
          });
        });
      }

      return this._giftCards;
    },
    set: function set(_giftCards) {
      var _this31 = this;

      runInAction(function () {
        _this31._giftCards = _giftCards;
      });
    }
  }, {
    key: "giftCardRecaptchaSiteKey",
    get: function get() {
      return this._giftCardRecaptchaSiteKey;
    }
  }, {
    key: "canAddGiftCard",
    get: function get() {
      return this._giftCards && this._giftCards.length < this.savedGiftCardsLimit;
    }
  }, {
    key: "creditCards",
    get: function get() {
      if (this.activePaymentTab === utils.PaymentMethods.PAY_AT_RESTAURANT || this.isOnlinePaySelected || this.isSelectedGiftCardsSufficient) {
        var _this$_creditCards;

        return (_this$_creditCards = this._creditCards) === null || _this$_creditCards === void 0 ? void 0 : _this$_creditCards.map(function (creditCard, i) {
          return _objectSpread(_objectSpread({}, creditCard), {}, {
            isSelected: false
          });
        });
      }

      return this._creditCards;
    }
  }, {
    key: "isSavedCreditCardSelected",
    get: function get() {
      return !!this.selectedCreditCard;
    }
  }, {
    key: "selectedCreditCard",
    get: function get() {
      var _this$creditCards;

      var selectedCards = (_this$creditCards = this.creditCards) === null || _this$creditCards === void 0 ? void 0 : _this$creditCards.filter(function (card) {
        return card.isSelected;
      });
      return selectedCards && selectedCards.length ? selectedCards[0] : null;
    }
  }, {
    key: "selectedCreditCardCVV",
    set: function set(val) {
      var _this32 = this;

      runInAction(function () {
        _this32.selectedCreditCard.paymentCVV = val;
      });
    }
  }, {
    key: "isSelectedGiftCardsSufficient",
    get: function get() {
      return this.selectedGCRemainingBal >= 0;
    }
  }, {
    key: "selectedGCRemainingBal",
    get: function get() {
      var selectedCards = this.giftCards.filter(function (item) {
        return item.isSelected;
      });
      var totalGCAmount = 0;
      selectedCards.forEach(function (card) {
        return totalGCAmount += card.card.giftCardBalance;
      });
      return totalGCAmount - this.orderTotalIncludingGratuity;
    }
  }, {
    key: "isAnyGiftCardSelected",
    get: function get() {
      return this.giftCards.filter(function (item) {
        return item.isSelected;
      }).length > 0;
    }
  }, {
    key: "isMaxGCLimit",
    get: function get() {
      var _this$appliedGiftCard;

      return ((_this$appliedGiftCard = this.appliedGiftCards) === null || _this$appliedGiftCard === void 0 ? void 0 : _this$appliedGiftCard.length) >= this.maximumGCAllowedPerOrder;
    }
  }, {
    key: "isGCFailureLimitReached",
    get: function get() {
      return this._isGCFailureLimitReached;
    },
    set: function set(val) {
      var _this33 = this;

      runInAction(function () {
        _this33._isGCFailureLimitReached = val;
      });
    }
  }, {
    key: "appliedGiftCards",
    get: function get() {
      var _this34 = this;

      var appliedGiftCards = [];
      var remainingBalance = this.orderTotalIncludingGratuity;
      var tipPercent = this.gratuity / this.orderTotalIncludingGratuity;
      var sortedCards = this.giftCards.slice().sort(function (a, b) {
        return a.selectionOrder - b.selectionOrder;
      });
      sortedCards.forEach(function (card) {
        if (card.isSelected) {
          var clonnedCard = _objectSpread({}, card);

          if (clonnedCard.card.giftCardBalance >= remainingBalance) {
            clonnedCard.amountUsed = remainingBalance;
            remainingBalance = 0;
          } else {
            clonnedCard.amountUsed = clonnedCard.card.giftCardBalance;
            remainingBalance = remainingBalance - clonnedCard.amountUsed;
          } //prorated


          var _this34$getAuthAndTip = _this34.getAuthAndTipAmounts(clonnedCard.amountUsed, tipPercent),
              authAmount = _this34$getAuthAndTip.authAmount,
              tipAmount = _this34$getAuthAndTip.tipAmount;

          clonnedCard.proratedAmount = authAmount;
          clonnedCard.proratedTip = tipAmount;
          appliedGiftCards.push(clonnedCard);
        }
      });
      return appliedGiftCards;
    }
  }, {
    key: "totalGCPaidAmount",
    get: function get() {
      var selectedCards = this.appliedGiftCards;
      var totalGCAmt = 0;
      selectedCards.forEach(function (card) {
        totalGCAmt += card.amountUsed;
      });
      return totalGCAmt;
    }
  }, {
    key: "totalGCAuthAndTipAmounts",
    get: function get() {
      var selectedCards = this.appliedGiftCards;
      var totalAuthAmount = 0;
      var totalTipAmount = 0;
      selectedCards.forEach(function (card) {
        totalAuthAmount += card.proratedAmount;
        totalTipAmount += card.proratedTip;
      });
      return {
        authAmount: totalAuthAmount,
        tipAmount: totalTipAmount
      };
    }
  }, {
    key: "remainingAuthAndTipAmounts",
    get: function get() {
      var authAndTipAmounts = this.totalGCAuthAndTipAmounts;
      var totalGCAuthAmount = authAndTipAmounts.authAmount;
      var totalGCTipAmount = authAndTipAmounts.tipAmount;

      if (totalGCAuthAmount > this.remainingOrderTotal) {
        // over paid on GC possibly because of abnormal tip amount.
        var tipPortionOnGCAuthAmount = totalGCAuthAmount - this.remainingOrderTotal;
        var remainingTip = common.roundTo(this.gratuity - (tipPortionOnGCAuthAmount + totalGCTipAmount), 2) - 0.01;
        return {
          authAmount: 0.01,
          tipAmount: remainingTip
        };
      } else {
        return {
          authAmount: common.roundTo(this.remainingOrderTotal - totalGCAuthAmount, 2),
          tipAmount: common.roundTo(this.gratuity - totalGCTipAmount, 2)
        };
      }
    }
  }, {
    key: "toPay",
    get: function get() {
      return this.orderTotalIncludingGratuity - this.totalGCPaidAmount;
    }
  }, {
    key: "orderAmount",
    get: function get() {
      if (this.orderPriceInfo) {
        return this.orderPriceInfo.rawSubTotal - (this.orderPriceInfo.discountAmount || 0);
      } else {
        return 0;
      }
    }
  }, {
    key: "orderTotal",
    get: function get() {
      var _this$orderPriceInfo, _this$orderPriceInfo2, _this$orderPriceInfo3;

      return this.orderAmount + (((_this$orderPriceInfo = this.orderPriceInfo) === null || _this$orderPriceInfo === void 0 ? void 0 : _this$orderPriceInfo.tax) || 0.0) + (((_this$orderPriceInfo2 = this.orderPriceInfo) === null || _this$orderPriceInfo2 === void 0 ? void 0 : _this$orderPriceInfo2.shipping) || 0.0) + (((_this$orderPriceInfo3 = this.orderPriceInfo) === null || _this$orderPriceInfo3 === void 0 ? void 0 : _this$orderPriceInfo3.bagFee) || 0.0);
    }
  }, {
    key: "remainingOrderTotal",
    get: function get() {
      return this.orderTotal - this.amountPaid;
    }
  }, {
    key: "amountPaid",
    get: function get() {
      var _this$orderPriceInfo4;

      return ((_this$orderPriceInfo4 = this.orderPriceInfo) === null || _this$orderPriceInfo4 === void 0 ? void 0 : _this$orderPriceInfo4.amountAlreadyPaid) || 0.0;
    }
  }, {
    key: "orderTotalIncludingGratuity",
    get: function get() {
      return this.remainingOrderTotal + this.gratuity;
    }
  }, {
    key: "cardAlreadySaved",
    get: function get() {
      var _this35 = this;

      var filteredCards = this.giftCards.filter(function (gc) {
        return gc.isSavedCard && gc.card.giftCardNumber === _this35.giftCardInfo.rawGCNumber;
      });
      return !!filteredCards.length;
    }
  }, {
    key: "payPalPaymentPayload",
    get: function get() {
      var _tokenData$paypalToke, _tokenData$paypalToke2, _this$payPalData, _this$payPalData$toke;

      var _this$remainingAuthAn = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn.authAmount,
          tipAmount = _this$remainingAuthAn.tipAmount;
      var tokenData = this.payPalData.tokenData;
      var approvalDetails = this.payPalData.approvalData.details;
      var payment = {
        authAmount: authAmount,
        amount: authAmount,
        tipAmount: tipAmount,
        paymentCardToken: tokenData === null || tokenData === void 0 ? void 0 : tokenData.paypalToken,
        expirationMonth: tokenData === null || tokenData === void 0 ? void 0 : tokenData.expiryMonth,
        expirationYear: tokenData === null || tokenData === void 0 ? void 0 : tokenData.expiryYear,
        cardAlias: tokenData === null || tokenData === void 0 ? void 0 : (_tokenData$paypalToke = tokenData.paypalToken) === null || _tokenData$paypalToke === void 0 ? void 0 : _tokenData$paypalToke.substring((tokenData === null || tokenData === void 0 ? void 0 : (_tokenData$paypalToke2 = tokenData.paypalToken) === null || _tokenData$paypalToke2 === void 0 ? void 0 : _tokenData$paypalToke2.length) - 4),
        authorizationId: (_this$payPalData = this.payPalData) === null || _this$payPalData === void 0 ? void 0 : (_this$payPalData$toke = _this$payPalData.tokenData) === null || _this$payPalData$toke === void 0 ? void 0 : _this$payPalData$toke.fdAuthorizationId,
        firstName: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.firstName,
        lastName: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.lastName,
        email: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.email,
        billingAddress: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.billingAddress,
        phone: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.phone
      };
      return {
        payPalPayment: payment
      };
    }
  }, {
    key: "payPalPaymentPayloadMP",
    get: function get() {
      var _this$payPalData2, _this$payPalData3, _this$payPalData4; //THIS IS FOR MOBILE PAY DO NOT CHANGE FOR CHECKOUT
      // Added tokenData for Pay Now - CALLIN/ETOGO payments


      var _this$remainingAuthAn2 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn2.authAmount,
          tipAmount = _this$remainingAuthAn2.tipAmount;
      var deviceData = this === null || this === void 0 ? void 0 : (_this$payPalData2 = this.payPalData) === null || _this$payPalData2 === void 0 ? void 0 : _this$payPalData2.deviceData;
      var approval = this === null || this === void 0 ? void 0 : (_this$payPalData3 = this.payPalData) === null || _this$payPalData3 === void 0 ? void 0 : _this$payPalData3.approvalData;
      var approvalDetails = approval === null || approval === void 0 ? void 0 : approval.details;
      var billingAddress = approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.billingAddress;
      var payment = {
        billingInfo: {
          firstName: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.firstName,
          lastName: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.lastName,
          email: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.email,
          phone: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.phone,
          line1: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.line1,
          line2: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.line2,
          city: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.city,
          postalCode: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode,
          state: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.state,
          countryCode: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.countryCode
        },
        transcationInfo: {
          nonce: approval === null || approval === void 0 ? void 0 : approval.nonce,
          type: approval === null || approval === void 0 ? void 0 : approval.type,
          correlationId: deviceData === null || deviceData === void 0 ? void 0 : deviceData.correlation_id,
          payerId: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.payerId
        },
        authAmount: authAmount,
        amount: authAmount,
        tipAmount: tipAmount,
        currencyCode: "USD"
      };

      if ((_this$payPalData4 = this.payPalData) !== null && _this$payPalData4 !== void 0 && _this$payPalData4.tokenData) {
        payment.tokenData = this.payPalData.tokenData;
      }

      return payment;
    }
  }, {
    key: "applePayPaymentPayload",
    get: function get() {
      var _this$remainingAuthAn3 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn3.authAmount,
          tipAmount = _this$remainingAuthAn3.tipAmount;
      var payment = {
        billingInfo: _objectSpread(_objectSpread({}, this.applePayAuthorization.shippingContact), this.applePayAuthorization.billingContact),
        transcationInfo: this.applePayAuthorization.token,
        authAmount: authAmount,
        amount: authAmount,
        tipAmount: tipAmount,
        currencyCode: "USD"
      };
      return {
        applePayPayment: payment
      };
    }
  }, {
    key: "googlePayPaymentPayload",
    get: function get() {
      var _this$remainingAuthAn4 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn4.authAmount,
          tipAmount = _this$remainingAuthAn4.tipAmount;
      var payment = {
        billingInfo: this.googlePayAuthorization.paymentMethodData.info,
        transcationInfo: this.googlePayAuthorization.paymentMethodData,
        authAmount: authAmount,
        amount: authAmount,
        tipAmount: tipAmount,
        currencyCode: "USD"
      };
      return {
        googlePayPayment: payment
      };
    }
  }, {
    key: "googlePayIsReadyToPayRequest",
    get: function get() {
      return {
        apiVersion: this.googlePayPaymentRequest.apiVersion,
        apiVersionMinor: this.googlePayPaymentRequest.apiVersionMinor,
        allowedPaymentMethods: this.googlePayPaymentRequest.allowedPaymentMethods,
        existingPaymentMethodRequired: true
      };
    }
  }, {
    key: "googlePayPaymentRequest",
    get: function get() {
      var _ref2, _appAttributes$google, _ref3, _appAttributes$google2, _appAttributes$google3, _appAttributes$google4, _appAttributes$concep, _appAttributes$concep2, _this$subTotalWithout, _this$orderPriceInfo5;

      var appAttributes = this.rootStore.common.appAttributes;

      var _appAttributes$config = appAttributes === null || appAttributes === void 0 ? void 0 : appAttributes.configs,
          paypalDisplayName = _appAttributes$config.paypalDisplayName;

      var paymentRequest = {
        apiVersion: 2,
        apiVersionMinor: 0,
        emailRequired: true,
        allowedPaymentMethods: [{
          type: "CARD",
          parameters: {
            allowedAuthMethods: (_ref2 = (_appAttributes$google = appAttributes.googlePayConfig) === null || _appAttributes$google === void 0 ? void 0 : _appAttributes$google.allowedAuthMethods.map(function (authMethod) {
              return authMethod.trim();
            })) !== null && _ref2 !== void 0 ? _ref2 : ["PAN_ONLY", "CRYPTOGRAM_3DS"],
            allowedCardNetworks: (_ref3 = (_appAttributes$google2 = appAttributes.googlePayConfig) === null || _appAttributes$google2 === void 0 ? void 0 : _appAttributes$google2.allowedCardNetworks.map(function (network) {
              return network.trim();
            })) !== null && _ref3 !== void 0 ? _ref3 : ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "VISA"],
            billingAddressRequired: true,
            billingAddressParameters: {
              format: "FULL",
              phoneNumberRequired: this.requestPhoneNumberFromAppleOrGooglePay ? true : false
            }
          },
          tokenizationSpecification: {
            type: "PAYMENT_GATEWAY",
            parameters: {
              gateway: (_appAttributes$google3 = (_appAttributes$google4 = appAttributes.googlePayConfig) === null || _appAttributes$google4 === void 0 ? void 0 : _appAttributes$google4.gateway) !== null && _appAttributes$google3 !== void 0 ? _appAttributes$google3 : "firstdata",
              gatewayMerchantId: this.googlePayGatewayMerchantId
            }
          }
        }],
        transactionInfo: {
          currencyCode: "USD",
          countryCode: "US",
          totalPriceStatus: "FINAL",
          totalPrice: this.toPay.toFixed(2),
          totalPriceLabel: this.isAnyGiftCardSelected || this.amountPaid ? "To Pay" : "Total",
          checkoutOption: "COMPLETE_IMMEDIATE_PURCHASE",
          displayItems: []
        },
        merchantInfo: {
          merchantId: this.googlePayPaymentMerchantId,
          merchantName: (_appAttributes$concep = (_appAttributes$concep2 = appAttributes.concept) === null || _appAttributes$concep2 === void 0 ? void 0 : _appAttributes$concep2.conceptCodeDesc) !== null && _appAttributes$concep !== void 0 ? _appAttributes$concep : paypalDisplayName
        },
        callbackIntents: ["PAYMENT_AUTHORIZATION"]
      };
      paymentRequest.transactionInfo.displayItems.push({
        label: "Subtotal",
        type: "SUBTOTAL",
        price: (_this$subTotalWithout = this.subTotalWithoutItemDiscount) === null || _this$subTotalWithout === void 0 ? void 0 : _this$subTotalWithout.toFixed(2),
        status: "FINAL"
      });

      if (this.couponModel.couponDiscount) {
        var couponDiscount = this.couponModel.couponDiscount;
        var discountAmountStr = couponDiscount ? couponDiscount.toFixed(2) : null;
        paymentRequest.transactionInfo.displayItems.push({
          label: "Coupon Discount",
          type: "DISCOUNT",
          price: discountAmountStr,
          status: "FINAL"
        });
      }

      if ((_this$orderPriceInfo5 = this.orderPriceInfo) !== null && _this$orderPriceInfo5 !== void 0 && _this$orderPriceInfo5.shipping) {
        paymentRequest.transactionInfo.displayItems.push({
          label: "Delivery",
          type: "SHIPPING_OPTION",
          price: this.orderPriceInfo.shipping.toFixed(2),
          status: "FINAL"
        });
      }

      paymentRequest.transactionInfo.displayItems.push({
        label: "Taxes",
        type: "TAX",
        price: this.orderPriceInfo ? this.orderPriceInfo.tax.toFixed(2) : "0.00",
        status: "FINAL"
      });
      paymentRequest.transactionInfo.displayItems.push({
        label: "Gratuity",
        type: "LINE_ITEM",
        price: this.gratuity ? this.gratuity.toFixed(2) : "0.00",
        status: "FINAL"
      });

      if (this.isAnyGiftCardSelected) {
        var appliedGiftCards = this.appliedGiftCards;
        appliedGiftCards.forEach(function (uiCard) {
          var amountUsed = uiCard.amountUsed,
              card = uiCard.card;
          var giftCardNumber = card.giftCardNumber;
          var last4 = giftCardNumber.substring(giftCardNumber.length - 4, giftCardNumber.length);
          paymentRequest.transactionInfo.displayItems.push({
            label: "Gift Card Ending With " + last4,
            type: "DISCOUNT",
            price: "-" + amountUsed.toFixed(2),
            status: "FINAL"
          });
        });
      }

      return paymentRequest;
    }
  }, {
    key: "applePayPaymentMerchantId",
    get: function get() {
      var _common$getEnvProps2 = common.getEnvProps(),
          NODE_ENV = _common$getEnvProps2.NODE_ENV,
          NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = _common$getEnvProps2.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV;

      var DEVELOPMENT = NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV === "development";
      var DEV_NODE_ENV = NODE_ENV === "development";
      var appAttributes = this.rootStore.common.appAttributes;

      if (DEV_NODE_ENV) {
        return "merchant.com.darden.sandbox.applepay";
      } else {
        var _appAttributes$appleP, _appAttributes$appleP2;

        return (_appAttributes$appleP = (_appAttributes$appleP2 = appAttributes.applePayConfig) === null || _appAttributes$appleP2 === void 0 ? void 0 : _appAttributes$appleP2.paymentMerchantId) !== null && _appAttributes$appleP !== void 0 ? _appAttributes$appleP : DEVELOPMENT ? "merchant.com.darden.sandbox.applepay" : "merchant.com.darden.applepay";
      }
    }
  }, {
    key: "googlePayPaymentMerchantId",
    get: function get() {
      var _common$getEnvProps3 = common.getEnvProps(),
          NODE_ENV = _common$getEnvProps3.NODE_ENV,
          NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = _common$getEnvProps3.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV;

      var DEVELOPMENT = NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV === "development";
      var DEV_NODE_ENV = NODE_ENV === "development";
      var appAttributes = this.rootStore.common.appAttributes;

      if (DEV_NODE_ENV) {
        return "BCR2DN6TSOQI33L7";
      } else {
        var _appAttributes$google5, _appAttributes$google6, _appAttributes$google7;

        return (_appAttributes$google5 = (_appAttributes$google6 = appAttributes.googlePayConfig) === null || _appAttributes$google6 === void 0 ? void 0 : _appAttributes$google6.paymentMerchantId) !== null && _appAttributes$google5 !== void 0 ? _appAttributes$google5 : DEVELOPMENT ? "BCR2DN6TSOQI33L7" : (_appAttributes$google7 = appAttributes.googlePayConfig) === null || _appAttributes$google7 === void 0 ? void 0 : _appAttributes$google7.paymentMerchantId;
      }
    }
  }, {
    key: "googlePayGatewayMerchantId",
    get: function get() {
      var _common$getEnvProps4 = common.getEnvProps(),
          NODE_ENV = _common$getEnvProps4.NODE_ENV,
          NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = _common$getEnvProps4.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV;

      var DEVELOPMENT = NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV === "development";
      var DEV_NODE_ENV = NODE_ENV === "development";
      var appAttributes = this.rootStore.common.appAttributes;

      if (DEV_NODE_ENV) {
        return "3176752955";
      } else {
        var _appAttributes$google8, _appAttributes$google9;

        return (_appAttributes$google8 = (_appAttributes$google9 = appAttributes.googlePayConfig) === null || _appAttributes$google9 === void 0 ? void 0 : _appAttributes$google9.gatewayMerchantId) !== null && _appAttributes$google8 !== void 0 ? _appAttributes$google8 : DEVELOPMENT ? "3176752955" : "376246695997";
      }
    }
  }, {
    key: "applePayPaymentRequest",
    get: function get() {
      var _appAttributes$appleP3, _appAttributes$appleP4, _appAttributes$appleP5, _appAttributes$appleP6, _appAttributes$concep3, _appAttributes$concep4, _this$subTotalWithout2, _this$orderPriceInfo6;

      var appAttributes = this.rootStore.common.appAttributes;

      var _appAttributes$config2 = appAttributes === null || appAttributes === void 0 ? void 0 : appAttributes.configs,
          paypalDisplayName = _appAttributes$config2.paypalDisplayName;

      var paymentRequest = {
        countryCode: "US",
        currencyCode: "USD",
        merchantCapabilities: (_appAttributes$appleP3 = (_appAttributes$appleP4 = appAttributes.applePayConfig) === null || _appAttributes$appleP4 === void 0 ? void 0 : _appAttributes$appleP4.allowedAuthMethods) !== null && _appAttributes$appleP3 !== void 0 ? _appAttributes$appleP3 : ["supports3DS"],
        supportedNetworks: (_appAttributes$appleP5 = (_appAttributes$appleP6 = appAttributes.applePayConfig) === null || _appAttributes$appleP6 === void 0 ? void 0 : _appAttributes$appleP6.allowedCardNetworks) !== null && _appAttributes$appleP5 !== void 0 ? _appAttributes$appleP5 : ["visa", "masterCard", "amex", "discover", "jcb"],
        requiredBillingContactFields: ["name", "postalAddress"],
        requiredShippingContactFields: this.rootStore.platformUtil.PLATFORM_TYPE === common.PlatformType.APP ? ["email"] : ["email", "name"],
        lineItems: [],
        total: {
          label: (_appAttributes$concep3 = (_appAttributes$concep4 = appAttributes.concept) === null || _appAttributes$concep4 === void 0 ? void 0 : _appAttributes$concep4.conceptCodeDesc) !== null && _appAttributes$concep3 !== void 0 ? _appAttributes$concep3 : paypalDisplayName,
          amount: this.toPay.toFixed(2),
          type: "final"
        }
      };

      if (this.requestPhoneNumberFromAppleOrGooglePay) {
        paymentRequest.requiredBillingContactFields.push("phone");
        paymentRequest.requiredShippingContactFields.push("phone");
      }

      if (!this.requestShippingFieldsFromAppleOrGooglePay) {
        delete paymentRequest.requiredShippingContactFields;
      }

      paymentRequest.lineItems.push({
        label: "Subtotal",
        amount: (_this$subTotalWithout2 = this.subTotalWithoutItemDiscount) === null || _this$subTotalWithout2 === void 0 ? void 0 : _this$subTotalWithout2.toFixed(2)
      });

      if (this.couponModel.couponDiscount) {
        var couponDiscount = this.couponModel.couponDiscount;
        var discountAmountStr = couponDiscount ? couponDiscount.toFixed(2) : null;
        paymentRequest.lineItems.push({
          label: "Coupon Discount",
          amount: discountAmountStr
        });
      }

      if ((_this$orderPriceInfo6 = this.orderPriceInfo) !== null && _this$orderPriceInfo6 !== void 0 && _this$orderPriceInfo6.shipping) {
        paymentRequest.lineItems.push({
          label: "Delivery",
          amount: this.orderPriceInfo.shipping.toFixed(2)
        });
      }

      paymentRequest.lineItems.push({
        label: "Taxes",
        amount: this.orderPriceInfo.tax.toFixed(2)
      });
      paymentRequest.lineItems.push({
        label: "Gratuity",
        amount: this.gratuity ? this.gratuity.toFixed(2) : "0.00"
      });

      if (this.isAnyGiftCardSelected) {
        var appliedGiftCards = this.appliedGiftCards;
        appliedGiftCards.forEach(function (uiCard) {
          var amountUsed = uiCard.amountUsed,
              card = uiCard.card;
          var giftCardNumber = card.giftCardNumber;
          var last4 = giftCardNumber.substring(giftCardNumber.length - 4, giftCardNumber.length);
          paymentRequest.lineItems.push({
            label: "Gift Card Ending With " + last4,
            amount: "-" + amountUsed.toFixed(2)
          });
        });
      }

      return paymentRequest;
    }
  }, {
    key: "payAtRestaurantPayload",
    get: function get() {
      var _this$remainingAuthAn5 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn5.authAmount,
          tipAmount = _this$remainingAuthAn5.tipAmount;
      var payment = {
        amount: authAmount,
        tipAmount: tipAmount
      };
      return {
        inStorePayment: payment
      };
    }
  }, {
    key: "savedCCPaymentPayload",
    get: function get() {
      var _this$selectedCreditC2;

      var userProfile = this.userProfile;
      var savedCard = (_this$selectedCreditC2 = this.selectedCreditCard) === null || _this$selectedCreditC2 === void 0 ? void 0 : _this$selectedCreditC2.card; //prorated

      var _this$remainingAuthAn6 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn6.authAmount,
          tipAmount = _this$remainingAuthAn6.tipAmount;
      var payment = {
        amount: authAmount,
        tipAmount: tipAmount,
        paymentCardToken: savedCard.paymentCardToken,
        creditCardType: savedCard.creditCardType,
        expirationMonth: Number(savedCard.expirationMonth),
        expirationYear: Number(savedCard.expirationYear),
        cardAlias: Number(savedCard.paymentCardToken.substring(savedCard.paymentCardToken.length - 4)),
        billingAddress: _objectSpread(_objectSpread({
          firstName: userProfile.firstName,
          lastName: userProfile.lastName
        }, savedCard.billingAddress), {}, {
          postalCode: savedCard.billingAddress.postalCode
        }),
        acceptClientType: this.isMobilePayFlowActive ? "mobile-mobilePay" : this.rootStore.acceptClientType,
        cardOnFile: true,
        isDefault: savedCard.isDefault,
        saveCardToProfile: false,
        paymentCVV: this.selectedCreditCard.paymentCVV
      };
      return payment;
    }
  }, {
    key: "formCCPaymentPayload",
    get: function get() {
      var creditCardInfo = this.creditCardInfo;
      var paymentToken = this.creditCardInfo.paymentToken; //prorated

      var _this$remainingAuthAn7 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn7.authAmount,
          tipAmount = _this$remainingAuthAn7.tipAmount;
      var account = creditCardInfo.cardAccount;
      var payment = {
        amount: authAmount,
        tipAmount: tipAmount,
        paymentCardToken: paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.paymentToken,
        creditCardType: paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.cardType,
        expirationMonth: Number(account.card.expMonth),
        expirationYear: Number(account.card.expYear),
        cardAlias: Number(account.card.cardNumber.substring(account.card.cardNumber.length - 4)),
        billingAddress: _objectSpread(_objectSpread({}, creditCardInfo.billingAddress), {}, {
          postalCode: creditCardInfo.billingAddress.postalCode
        }),
        acceptClientType: this.isMobilePayFlowActive ? "mobile-mobilePay" : this.rootStore.acceptClientType,
        paymentCVV: creditCardInfo === null || creditCardInfo === void 0 ? void 0 : creditCardInfo.cvv,
        cardOnFile: creditCardInfo.saveCreditCard,
        isDefault: creditCardInfo.isDefault,
        saveCardToProfile: creditCardInfo.saveCreditCard
      };

      if (creditCardInfo.isCardCVVValid && creditCardInfo.cvv) {
        payment.paymentCVV = creditCardInfo.cvv;
      }

      return payment;
    }
  }, {
    key: "gcPaymentPayload",
    get: function get() {
      var selectedGCs = this.appliedGiftCards.map(function (gCard) {
        var payment = {
          giftCardNumber: Number(gCard.card.giftCardNumber.split("-").join("")),
          amount: gCard.proratedAmount,
          tipAmount: gCard.proratedTip
        };
        return payment;
      });
      return {
        giftCards: selectedGCs
      };
    }
  }, {
    key: "isPayAtRest",
    get: function get() {
      return this._activePaymentTab === utils.PaymentMethods.PAY_AT_RESTAURANT;
    }
  }, {
    key: "isSmartPaySelected",
    get: function get() {
      return this.toPay > 0 && this._activePaymentTab === utils.PaymentMethods.ONLINE && (this._activeOtherOptionTab === utils.OnlinePaymentTypes.PAYPAL || this._activeOtherOptionTab === utils.OnlinePaymentTypes.GOOGLE_PAY || this._activeOtherOptionTab === utils.OnlinePaymentTypes.APPLE_PAY);
    }
  }, {
    key: "isOnlinePaySelected",
    get: function get() {
      return this.toPay > 0 && this._activePaymentTab === utils.PaymentMethods.ONLINE && (this._activeOtherOptionTab === utils.OnlinePaymentTypes.CREDIT_CARD || this._activeOtherOptionTab === utils.OnlinePaymentTypes.PAYPAL || this._activeOtherOptionTab === utils.OnlinePaymentTypes.GOOGLE_PAY || this._activeOtherOptionTab === utils.OnlinePaymentTypes.APPLE_PAY);
    }
  }, {
    key: "bamsCorrelationId",
    get: function get() {
      var _this$sessionToken;

      return (_this$sessionToken = this.sessionToken) === null || _this$sessionToken === void 0 ? void 0 : _this$sessionToken.correlationID;
    }
  }, {
    key: "payPalErrored",
    get: function get() {
      return this._payPalErrored;
    },
    set: function set(val) {
      var _this36 = this;

      runInAction(function () {
        _this36._payPalErrored = val;
      });
    }
  }, {
    key: "applePayErrored",
    get: function get() {
      return this._applePayErrored;
    },
    set: function set(val) {
      var _this37 = this;

      runInAction(function () {
        _this37._applePayErrored = val;
      });
    }
  }, {
    key: "googlePayErrored",
    get: function get() {
      return this._googlePayErrored;
    },
    set: function set(val) {
      var _this38 = this;

      runInAction(function () {
        _this38._googlePayErrored = val;
      });
    }
  }, {
    key: "isPayPalEnabled",
    get: function get() {
      return this._isPayPalEnabled;
    },
    set: function set(isPayPalEnabled) {
      var _this39 = this;

      runInAction(function () {
        _this39._isPayPalEnabled = isPayPalEnabled;
      });
    }
  }, {
    key: "isGiftCardPaymentEnabled",
    get: function get() {
      return this._isGiftCardPaymentEnabled;
    },
    set: function set(isGiftCardPaymentEnabled) {
      var _this40 = this;

      runInAction(function () {
        _this40._isGiftCardPaymentEnabled = isGiftCardPaymentEnabled;
      });
    }
  }, {
    key: "isGooglePayEnabled",
    get: function get() {
      return this._isGooglePayEnabled;
    },
    set: function set(isGooglePayEnabled) {
      var _this41 = this;

      runInAction(function () {
        _this41._isGooglePayEnabled = isGooglePayEnabled;
      });
    }
  }, {
    key: "isApplePayEnabled",
    get: function get() {
      return this._isApplePayEnabled;
    },
    set: function set(isApplePayEnabled) {
      var _this42 = this;

      runInAction(function () {
        _this42._isApplePayEnabled = isApplePayEnabled;
      });
    }
  }, {
    key: "applePaySession",
    get: function get() {
      return this._applePaySession;
    },
    set: function set(applePaySession) {
      var _this43 = this;

      runInAction(function () {
        _this43._applePaySession = applePaySession;
      });
    }
  }, {
    key: "applePayAuthorization",
    get: function get() {
      return this._applePayAuthorization;
    },
    set: function set(applePayAuthorization) {
      var _this44 = this;

      runInAction(function () {
        _this44._applePayAuthorization = applePayAuthorization;
      });
    }
  }, {
    key: "googlePayAuthorization",
    get: function get() {
      return this._googlePayAuthorization;
    },
    set: function set(googlePayAuthorization) {
      var _this45 = this;

      runInAction(function () {
        _this45._googlePayAuthorization = googlePayAuthorization;
      });
    }
  }, {
    key: "fallbackReasonCode",
    get: function get() {
      return this._fallbackReasonCode;
    },
    set: function set(val) {
      var _this46 = this;

      runInAction(function () {
        _this46._fallbackReasonCode = val;
      });
    }
  }, {
    key: "errorsYPosition",
    get: function get() {
      return this._errorsYPosition;
    }
  }, {
    key: "showError",
    get: function get() {
      return this._showError;
    }
  }, {
    key: "payPalPaymentRequest",
    get: function get() {
      var _this$subTotalWithout3, _this$orderPriceInfo7;

      var appAttributes = this.rootStore.common.appAttributes;

      var _appAttributes$config3 = appAttributes === null || appAttributes === void 0 ? void 0 : appAttributes.configs,
          paypalDisplayName = _appAttributes$config3.paypalDisplayName,
          paypalAuthorizationID = _appAttributes$config3.paypalAuthorizationID;

      var paymentRequest = {
        authorization: paypalAuthorizationID,
        displayName: paypalDisplayName,
        offerCredit: false,
        isShippingAddressRequired: false,
        isShippingAddressEditable: true,
        lineItems: [],
        landingPageType: "default"
      };
      paymentRequest.lineItems.push({
        name: "Subtotal",
        unitAmount: (_this$subTotalWithout3 = this.subTotalWithoutItemDiscount) === null || _this$subTotalWithout3 === void 0 ? void 0 : _this$subTotalWithout3.toFixed(2),
        kind: "credit",
        quantity: "1"
      });

      if (this.couponModel.couponDiscount) {
        var couponDiscount = this.couponModel.couponDiscount;
        var discountAmountStr = couponDiscount ? couponDiscount.toFixed(2) : null;
        paymentRequest.lineItems.push({
          name: "Coupon Discount",
          unitAmount: discountAmountStr,
          kind: "credit",
          quantity: "1"
        });
      }

      if ((_this$orderPriceInfo7 = this.orderPriceInfo) !== null && _this$orderPriceInfo7 !== void 0 && _this$orderPriceInfo7.shipping) {
        paymentRequest.lineItems.push({
          name: "Delivery",
          unitAmount: this.orderPriceInfo.shipping.toFixed(2),
          kind: "credit",
          quantity: "1"
        });
      }

      paymentRequest.lineItems.push({
        name: "Taxes",
        unitAmount: this.orderPriceInfo.tax.toFixed(2),
        kind: "credit",
        quantity: "1"
      });
      paymentRequest.lineItems.push({
        name: "Gratuity",
        unitAmount: this.gratuity ? this.gratuity.toFixed(2) : "0.00",
        kind: "credit",
        quantity: "1"
      });

      if (this.isAnyGiftCardSelected) {
        var appliedGiftCards = this.appliedGiftCards;
        appliedGiftCards.forEach(function (uiCard) {
          var amountUsed = uiCard.amountUsed,
              card = uiCard.card;
          var giftCardNumber = card.giftCardNumber;
          var last4 = giftCardNumber.substring(giftCardNumber.length - 4, giftCardNumber.length);
          paymentRequest.lineItems.push({
            name: "Gift Card Ending With " + last4,
            unitAmount: "-" + amountUsed.toFixed(2),
            kind: "credit",
            quantity: "1"
          });
        });
      }

      return paymentRequest;
    }
  }, {
    key: "orderSessionRSARetryCount",
    set: function set(_orderSessionRSARetryCount) {
      var _this47 = this;

      runInAction(function () {
        _this47._orderSessionRSARetryCount = _orderSessionRSARetryCount;
      });
    },
    get: function get() {
      return this._orderSessionRSARetryCount;
    }
  }, {
    key: "isOrderSessionRSARetryCountExhausted",
    get: function get() {
      return this._orderSessionRSARetryCount <= 0;
    }
  }, {
    key: "isGCLimitExceeded",
    get: function get() {
      return this._isGCLimitExceeded;
    },
    set: function set(_isGCLimitExceeded) {
      var _this48 = this;

      runInAction(function () {
        _this48._isGCLimitExceeded = _isGCLimitExceeded;
      });
    }
  }, {
    key: "isCCLimitExceeded",
    get: function get() {
      return this._isCCLimitExceeded;
    },
    set: function set(_isCCLimitExceeded) {
      var _this49 = this;

      runInAction(function () {
        _this49._isCCLimitExceeded = _isCCLimitExceeded;
      });
    }
  }, {
    key: "trackingIdWRTFlow",
    get: function get() {
      var _this$rootStore$user$;

      return this.flow === utils.PaymentFlow.PROFILE ? this.rootStore.user.userProfile.userId : this.isMobilePayFlowActive ? this.rootStore.mobilePay.checkModel.paymentCode : (_this$rootStore$user$ = this.rootStore.user.sessionDetails.orderContext) === null || _this$rootStore$user$ === void 0 ? void 0 : _this$rootStore$user$.orderId;
    }
  }]);

  return Payment;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_userProfile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_activePaymentTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_activeOtherOptionTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_giftCards", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_creditCards", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_subTotalWithoutItemDiscount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_paymentCVV", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_componentRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_paymentCVVEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_sessionToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_rsaToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_encryptionFields", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_isCCPaymentDisabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_payPalErrored", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_applePayErrored", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_googlePayErrored", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_isGCFailureLimitReached", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "giftCardInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_payPalData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_savedGiftCardsLimit", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_orderPriceInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_tippableAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_formSubmitted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_isPayPalEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_isGooglePayEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "_isApplePayEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "_isGiftCardPaymentEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "_allowedPaymentMethods", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "PAY_ONLINE";
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "_giftCardRecaptchaSiteKey", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "_applePaySession", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "_applePayAuthorization", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "_googlePayAuthorization", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "_fallbackReasonCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "_flow", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "_maximumGCAllowedPerOrder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "_errorsYPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "_showError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "_requestPhoneNumberFromAppleOrGooglePay", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "_orderSessionRSARetryCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "_requestShippingFieldsFromAppleOrGooglePay", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "_isGCLimitExceeded", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "_isCCLimitExceeded", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "activePaymentTab", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activePaymentTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "flow", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "flow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "paymentCVVEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentCVVEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "requestPhoneNumberFromAppleOrGooglePay", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "requestPhoneNumberFromAppleOrGooglePay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "requestShippingFieldsFromAppleOrGooglePay", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "requestShippingFieldsFromAppleOrGooglePay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formSubmitted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formSubmitted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeOtherOptionTab", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeOtherOptionTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "paymentCVV", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentCVV"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "smartPayOptionsEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "smartPayOptionsEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allowedPaymentMethods", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allowedPaymentMethods"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onlinePaymentsOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "onlinePaymentsOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCCPaymentDisabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCCPaymentDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderPriceInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderPriceInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tippableAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tippableAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subTotalWithoutItemDiscount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subTotalWithoutItemDiscount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionToken", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sessionToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rsaToken", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rsaToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "encryptionFields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "encryptionFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payPalData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payPalData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMobilePayFlowActive", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMobilePayFlowActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "componentRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "componentRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savedGiftCardsLimit", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "savedGiftCardsLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maximumGCAllowedPerOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maximumGCAllowedPerOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gratuity", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "gratuity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addNewGiftCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addNewGiftCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearGiftCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearGiftCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "giftCards", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "giftCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "giftCardRecaptchaSiteKey", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "giftCardRecaptchaSiteKey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canAddGiftCard", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canAddGiftCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "creditCards", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "creditCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCreditCards", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCreditCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectCreditCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectCreditCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deSelectCreditCards", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deSelectCreditCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deSelectGiftCards", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deSelectGiftCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSavedCreditCardSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSavedCreditCardSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedCreditCard", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedCreditCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSelectedGiftCardsSufficient", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSelectedGiftCardsSufficient"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedGCRemainingBal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedGCRemainingBal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAnyGiftCardSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAnyGiftCardSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMaxGCLimit", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMaxGCLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGCFailureLimitReached", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGCFailureLimitReached"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeGiftCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeGiftCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appliedGiftCards", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appliedGiftCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalGCPaidAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalGCPaidAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalGCAuthAndTipAmounts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalGCAuthAndTipAmounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingAuthAndTipAmounts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "remainingAuthAndTipAmounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toPay", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "toPay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderTotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingOrderTotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "remainingOrderTotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "amountPaid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "amountPaid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderTotalIncludingGratuity", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTotalIncludingGratuity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardAlreadySaved", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardAlreadySaved"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payPalPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payPalPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payPalPaymentPayloadMP", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payPalPaymentPayloadMP"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applePayPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "applePayPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayIsReadyToPayRequest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayIsReadyToPayRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayPaymentRequest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayPaymentRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applePayPaymentMerchantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "applePayPaymentMerchantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayPaymentMerchantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayPaymentMerchantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayGatewayMerchantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayGatewayMerchantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applePayPaymentRequest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "applePayPaymentRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payAtRestaurantPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payAtRestaurantPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savedCCPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "savedCCPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formCCPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formCCPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gcPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "gcPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPayAtRest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPayAtRest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSmartPaySelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSmartPaySelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOnlinePaySelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOnlinePaySelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bamsCorrelationId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "bamsCorrelationId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payPalErrored", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payPalErrored"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applePayErrored", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "applePayErrored"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayErrored", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayErrored"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fallbackReasonCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fallbackReasonCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorsYPosition", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorsYPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payPalPaymentRequest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payPalPaymentRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderSessionRSARetryCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderSessionRSARetryCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderSessionRSARetryCountExhausted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderSessionRSARetryCountExhausted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGCLimitExceeded", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGCLimitExceeded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCCLimitExceeded", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCCLimitExceeded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackingIdWRTFlow", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "trackingIdWRTFlow"), _class.prototype)), _class);
export { Payment as default };